//goods recipts
//goodsreceipt
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Layout from "../../Component/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CharacteristicsModal from "../../Component/CharacteristicsModal ";
import { MASTER_API, PURCHASE_API } from "../../apiConfig";
import { authHeaders } from "../../utils/authHeaders";
import { FaTrash } from "react-icons/fa";
import Select from "react-select";
import { jsPDF } from "jspdf";
import sbeeLogo from "../../assets/sbeelogo.png";
import { FileText } from 'lucide-react';

// TODO(Maithili): confirm this is the actual route for the Gate Pass page —
// update this one line if it's different.
const GATE_PASS_ROUTE = "/cable/inbound/gate-pass";

const styles = {
  compactLabel: {
    fontSize: "12px",
    fontWeight: 600,
    marginBottom: "2px",
    color: "#334155"
  },
  compactInput: {
    fontSize: "14px",
    height: "32px",
    padding: "4px 8px"
  },
  compactTabBtn: {
    fontSize: "14px",
    padding: "4px 10px"
  },
  tableContainer: {
    background: "#ffffff",
    borderRadius: 8,
    padding: 12,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },
  erpTable: {
    width: "100%",
    minWidth: "600px",
    tableLayout: "fixed",
    borderCollapse: "collapse"
  },
  erpTh: {
    background: "#f8fafc",
    fontSize: 13,
    fontWeight: 600,
    padding: "10px 12px",
    borderBottom: "1px solid #e5e7eb",
    color: "#1e293b",
    whiteSpace: "nowrap"
  },
  erpTd: {
    fontSize: 13,
    padding: "10px 12px",
    borderBottom: "1px solid #f1f5f9",
    color: "#334155",
    verticalAlign: "middle"
  },
  filterCard: {
    background: '#ffffff',
    borderRadius: 8,
    padding: 20,
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    marginBottom: 18
  },
  filterLabel: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
    color: '#334155'
  },
  filterSelect: {
    height: 36,
    fontSize: 13
  },
  pageTitleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  pageTitle: {
    fontSize: 26,
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: 2
  },
  pageSubtitle: {
    fontSize: 13,
    color: '#64748b'
  },
  primaryBtn: { paddingLeft: 14, paddingRight: 14 },
  modalBackdrop: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1050,
    padding: '20px',
  },
  modal: {
    background: '#fff',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '1200px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  modalHeader: {
    padding: '15px 20px',
    borderBottom: '1px solid #ddd',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconBtn: {
    background: 'transparent',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
  },
  modalBody: {
    padding: '20px',
    overflowY: 'auto',
    flex: 1,
  },
  modalFooter: {
    padding: '15px 20px',
    borderTop: '1px solid #ddd',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  tabs: {
    display: 'flex',
    gap: 8,
    margin: '14px 0',
  },
};

/* react-select compact style — matches PurchaseOrder.js rsCompact exactly (font/size) */
const rsCompact = {
  control: (base) => ({
    ...base,
    minHeight: "32px",
    height: "32px",
    fontSize: "13px",
    borderColor: "#ced4da",
    boxShadow: "none",
    "&:hover": { borderColor: "#86b7fe" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: "32px" }),
  menu: (base) => ({ ...base, zIndex: 99999, fontSize: "13px", position: "absolute" }),
  menuPortal: (base) => ({ ...base, zIndex: 100000 }),
};

/* react-select compact style for filter dropdowns */
const rsFilter = {
  control: (base) => ({
    ...base,
    height: "36px",
    minHeight: "36px",
    fontSize: "13px",
    borderColor: "#ced4da",
    boxShadow: "none",
    "&:hover": { borderColor: "#86b7fe" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: "36px" }),
  menu: (base) => ({ ...base, zIndex: 99999, fontSize: "13px", position: "absolute" }),
  menuPortal: (base) => ({ ...base, zIndex: 100000 }),
};

const USER_MANUAL_SCOPE = {
    moduleName: "Logistics",
    process: "Inbound",
    subProcess: "Goods Receipt"
};
const USER_MANUAL_LIST_API = `${MASTER_API}/user-manual/list`;


/* ===================== HELPERS ===================== */

// Returns the logged-in user's display name (matches PurchaseOrder.js behavior)
function getCurrentUser() {
  const userObj = localStorage.getItem("user");
  if (userObj) {
    try {
      const parsedUser = JSON.parse(userObj);
      // Prefer the full name; the backend stamps the real name on save.
      const fullName = `${parsedUser.firstName || ''} ${parsedUser.lastName || ''}`.trim();
      if (fullName) return fullName;
      if (parsedUser.userId) return parsedUser.userId;
      if (parsedUser.email) return parsedUser.email;
    } catch (e) {
      console.error("Error parsing user data:", e);
    }
  }
  const storedUserId = localStorage.getItem("userId");
  if (storedUserId && storedUserId !== "undefined" && storedUserId !== "null") return storedUserId;
  const storedName = localStorage.getItem("userName");
  if (storedName && storedName !== "undefined" && storedName !== "null") return storedName;
  return "";
}

// Reads the JWT's own "role" claim rather than trusting a separate
// localStorage "role" key — that key turned out to not exist in this app
// at all (confirmed: localStorage.getItem("role") -> null even for a real
// hardcoded admin login), which was silently defeating every admin-bypass
// check below. The token itself always has the real role, wherever it's
// stored, so decode it directly instead of guessing another storage key.
function getAuthRole() {
  let token = localStorage.getItem("token");
  if (!token) {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      token = user?.token || null;
    } catch (e) {
      token = null;
    }
  }
  if (!token) return null;
  try {
    // JWTs are base64url-encoded; atob() needs standard base64 + padding.
    const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4)));
    // Lower-cased so "Admin" / "ADMIN" still match the admin check.
    return payload?.role ? String(payload.role).toLowerCase() : null;
  } catch (e) {
    return null;
  }
}

// Reads the INBOUND_GOODS_RECEIPT permissions the login response stored, e.g.
// [{ module_id: "INBOUND_GOODS_RECEIPT", can_view: 1, can_create: 1, can_edit: 0 }, ...]
// Same shape authController.login returns and utils/permission.js already
// reads for other modules — admins (role decoded from the JWT itself) always pass.
function getGRNPermission() {
  const role = getAuthRole();
  if (role === "admin") {
    return { can_view: true, can_create: true, can_edit: true };
  }
  try {
    // Login stores permissions inside the "user" object (user.permissions);
    // a standalone "permissions" key is kept only as a fallback.
    let permissions = [];
    try {
      const userObj = JSON.parse(localStorage.getItem("user") || "{}");
      if (Array.isArray(userObj?.permissions)) permissions = userObj.permissions;
    } catch (e) { /* ignore, fall through to fallback */ }
    if (permissions.length === 0) {
      permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
    }
    const grn = permissions.find(
      (p) => p.module_id === "INBOUND_GOODS_RECEIPT" || p.module_id === "GOODS_RECEIPT"
    );
    return {
      can_view: !!grn?.can_view,
      can_create: !!grn?.can_create,
      can_edit: !!grn?.can_edit
    };
  } catch (e) {
    console.error("Error reading GRN permissions:", e);
    return { can_view: false, can_create: false, can_edit: false };
  }
}

// Returns today's date as YYYY-MM-DD in LOCAL timezone (not UTC) — used for storage
function getTodayLocal() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Formats any YYYY-MM-DD / ISO date string as dd/mm/yyyy for display
function formatDateDMY(dateStr) {
  if (!dateStr) return "";
  let iso = dateStr;
  if (typeof dateStr === "string" && dateStr.includes("T")) {
    iso = dateStr.split("T")[0];
  }
  const parts = String(iso).split("-");
  if (parts.length === 3) {
    const [y, m, d] = parts;
    return `${d}/${m}/${y}`;
  }
  return dateStr;
}

/* ===================== COMPONENT ===================== */

const GoodsReceipt = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Read logged-in user from localStorage (adjust the key to match your auth setup)
  const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");
  // Prefer the actual user id so created_by is stored as the user id, not the email.
  const createdBy = `${loggedInUser?.firstName || ""} ${loggedInUser?.lastName || ""}`.trim() || loggedInUser?.userId || loggedInUser?.email || loggedInUser?.name || loggedInUser?.username || "";
  const grnPermission = getGRNPermission();
  // Logged-in user's "First Last", fetched from the backend (the cached
  // localStorage "user" object usually has no firstName/lastName).
  const [currentUserName, setCurrentUserName] = useState(getCurrentUser());
  useEffect(() => {
    axios
      .get(`${PURCHASE_API}/goods-receipt/current-user`, { headers: authHeaders() })
      .then((r) => { if (r.data?.name) setCurrentUserName(r.data.name); })
      .catch(() => {});
  }, []);
  const [grnList, setGrnList] = useState([]);

  const [activeTab, setActiveTab] = useState("active");

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  //eslint-disable-next-line
  const [isEditMode, setIsEditMode] = useState(false);

  const [showManual, setShowManual] = useState(false);
  const [manualExists, setManualExists] = useState(null);
  const [manualFile, setManualFile] = useState(null);

  const [purchaseOrganizations, setPurchaseOrganizations] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [receivedData, setReceivedData] = useState({});
  const [invoiceNo, setInvoiceNo] = useState("");
  const [batchData, setBatchData] = useState({});
  const [generatedGRN, setGeneratedGRN] = useState("");

  // Product-level characteristics modal
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);
  const [modalIndex, setModalIndex] = useState(null);

  const [paymentTermNumber, setPaymentTermNumber] = useState("");
  //eslint-disable-next-line
  const [paymentTermUnit, setPaymentTermUnit] = useState("");
  const [isManualGRN, setIsManualGRN] = useState(false);
  //eslint-disable-next-line
  const [products, setProducts] = useState([]);
  const [manualPurchaseOrgs, setManualPurchaseOrgs] = useState([]);
  const [manualPurchasePlanners, setManualPurchasePlanners] = useState([]);
  const [manualLocations, setManualLocations] = useState([]);
  const [showGrnViewModal, setShowGrnViewModal] = useState(false);
  const [vendorList, setVendorList] = useState([]);

  const [filterCategory, setFilterCategory] = useState("");
  const [filterSubCategory, setFilterSubCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [grnPdfBlob, setGrnPdfBlob] = useState(null);
  // GRN document upload (Docs tab) — mirrors PurchaseRequisition.js's Docs
  // tab. uploadedGrnDocs stages files locally BEFORE the GRN has a number
  // (they're sent along with the initial Save/Short Close request, since
  // there's no grn_number yet to upload against). uploadedDocs is the
  // server-side (Drive-backed) list, fetched via list-docs once generatedGRN
  // exists — same distinction PR draws via modalData?.purchase_request_no.
  const [uploadedGrnDocs, setUploadedGrnDocs] = useState([]);
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [docsUploading, setDocsUploading] = useState(false);
  // Upload size limit — configurable via Configuration → File Size Config
  // (Module = "Goods Receipt"). Falls back to 50 KB if it can't be fetched.
  const DEFAULT_MAX_GRN_DOC_SIZE_KB = 50;
  const [maxGrnDocSizeKb, setMaxGrnDocSizeKb] = useState(DEFAULT_MAX_GRN_DOC_SIZE_KB);
  const [showSupplierBatchModal, setShowSupplierBatchModal] = useState(false);
  const [supplierBatches, setSupplierBatches] = useState([{ batch_number: "", qty: "", uom: "" }]);
  const [currentRowIndex, setCurrentRowIndex] = useState(null);

  const [filters, setFilters] = useState({
    purchaseOrganization: "",
    purchaseOrderId: "",
    supplier: ""
  });

  const [showProductModal, setShowProductModal] = useState(false);
  const [productDetails, setProductDetails] = useState(null);


  const [modeOfTransports, setModeOfTransports] = useState([]);
  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [freightTerms, setFreightTerms] = useState([]);
  const [insuranceTerms, setInsuranceTerms] = useState([]);
  const [transporters, setTransporters] = useState([]);
  const [purchaseTypes, setPurchaseTypes] = useState([]);
  const [stateGroupings, setStateGroupings] = useState([]);
  const [poHeaderLotTypes, setPoHeaderLotTypes] = useState([]);
  const [storageLocations, setStorageLocations] = useState([]);

  // Default storage location for new GRN rows — "Inward Area". The dropdown
  // is left fully editable, so the user can still pick any other storage
  // location; this just pre-fills it instead of leaving the field blank.
  const DEFAULT_STORAGE_LOCATION_NAME = "Inward Area";
  const getDefaultStorageLocation = (list = storageLocations) => {
    const match = (list || []).find(
      (item) =>
        String(item.storage_location || "").trim().toLowerCase() ===
        DEFAULT_STORAGE_LOCATION_NAME.toLowerCase()
    );
    return {
      storage_location: match ? match.storage_location : "",
      storage_code: match ? match.storage_code : "",
    };
  };

  const [createActiveTab, setCreateActiveTab] = useState("basic");

  // Product Type (header field, mirrors PurchaseOrder.js)
  const [productTypeOptions, setProductTypeOptions] = useState([]);

  const handleReceivedChange = (idx, field, value) => {
    setReceivedData(prev => ({
      ...prev,
      [idx]: { ...prev[idx], [field]: value }
    }));

    // Manual GRN: there's no separate "Qty" input — whatever qty is entered
    // in Received Qty IS the qty for that line, so keep requirement_qty in sync.
    if (isManualGRN && field === "received_qty") {
      setModalData(prev => {
        const updated = [...prev];
        if (updated[idx]) {
          updated[idx] = { ...updated[idx], requirement_qty: value };
        }
        return updated;
      });
    }
  };

  // ── Row insert / delete helpers: keep index-keyed state aligned with modalData ──
  const shiftKeysUp = (obj, at) => {
    const next = {};
    Object.keys(obj || {}).forEach(k => {
      const ki = parseInt(k, 10);
      next[Number.isNaN(ki) ? k : (ki >= at ? ki + 1 : ki)] = obj[k];
    });
    return next;
  };
  const shiftKeysDown = (obj, at) => {
    const next = {};
    Object.keys(obj || {}).forEach(k => {
      const ki = parseInt(k, 10);
      if (Number.isNaN(ki)) { next[k] = obj[k]; return; }
      if (ki < at) next[ki] = obj[k];
      else if (ki > at) next[ki - 1] = obj[k];
    });
    return next;
  };
  const makeBlankGRRow = () => ({
    purchase_order_id: "", purchase_organization: "", purchase_planner: "", location: "",
    vendor_name: "", product_code: "", description: "", uom: "", currency: "",
    product_class: "", requirement_qty: "", open_po_qty: "", requirement_date: "", product_cost: ""
  });
  const insertGRRowAfter = (idx) => {
    const at = idx + 1;
    setModalData(prev => [...prev.slice(0, at), makeBlankGRRow(), ...prev.slice(at)]);
    setBatchData(prev => shiftKeysUp(prev, at));
    setReceivedData(prev => shiftKeysUp(prev, at));
  };
  const deleteGRRow = (idx) => {
    setModalData(prev => prev.filter((_, i) => i !== idx));
    setBatchData(prev => shiftKeysDown(prev, idx));
    setReceivedData(prev => shiftKeysDown(prev, idx));
  };

  const handleBatchChange = (idx, value) => {
    setBatchData(prev => ({ ...prev, [idx]: value }));
  };


  const handleVendorSelect = async (vendorName) => {
    if (!vendorName) { setPaymentTermNumber(""); setPaymentTermUnit(""); return; }
    try {
      const vendor = vendorList.find(v => v.business_partner_name === vendorName);
      if (!vendor?.partner_code) return;
      const res = await axios.get(`${PURCHASE_API}/po/business-partner/${vendor.partner_code}`, { headers: authHeaders() });
      const vTerms = res.data.payment_terms || res.data.terms_and_conditions || "";
      setPaymentTermNumber(String(vTerms).substring(0, 50));
      setPaymentTermUnit("");
    } catch (err) {
      console.error("Error fetching vendor payment terms:", err);
    }
  };

  const handleCreateManualGRN = () => {
    setPaymentTermNumber("");
    setPaymentTermUnit("");
    setIsManualGRN(true);


    setModalData([
      {
        purchase_order_id: "",
        purchase_organization: "SB01",
        purchase_planner: "",
        location: "",
        vendor_name: "",
        product_code: "",
        product_type: "",
        description: "",
        uom: "",
        requirement_qty: "",
        open_po_qty: "",
        requirement_date: "",
        product_cost: "",
        mode_of_transport: "",
        delivery_type: "",
        freight_terms: "",
        insurance_terms: "",
        transporter: "",
        purchase_type: "",
        state_grouping: "",
        po_header_lot_type: "",
        ...getDefaultStorageLocation(),
        created_by: currentUserName,
        created_date: getTodayLocal(),
      }
    ]);
    setGeneratedGRN("");
    setShowModal(true);
    setIsEditMode(true);
    setCreateActiveTab("basic");
    setFilterCategory("");
    setFilterSubCategory("");
  };

  /* ===================== FETCH DROPDOWNS ===================== */
  useEffect(() => {
    axios.get(`${PURCHASE_API}/goods-receipt/po-filters`, { headers: authHeaders() })
      .then(res => {
        setPurchaseOrganizations(res.data.purchaseOrganizations || []);
        setPurchaseOrders(res.data.purchaseOrders || []);
        setSuppliers(res.data.suppliers || []);
      })
      .catch(err => console.error(err));
  }, []);



  useEffect(() => {
    axios.get(`${PURCHASE_API}/goods-receipt/list`, { headers: authHeaders(), params: { ...filters, tab: activeTab } })
      .then(res => setGrnList(res.data || []))
      .catch(err => console.error(err));
  }, [filters, activeTab]);

  // Automatically open the GRN view modal if the URL tells us to (e.g. coming from
  // a "GRN No" hyperlink on another screen like Vendor Return).
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const viewGrnNo = queryParams.get("view");

    if (viewGrnNo && !showModal) {
      viewGRN(viewGrnNo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    axios.get(`${PURCHASE_API}/goods-receipt/products`, { headers: authHeaders() })
      .then((res) => { setProducts(res.data || []); })
      .catch(console.error);

    axios.get(`${PURCHASE_API}/po/product-details`, { headers: authHeaders() })
      .then((res) => setAllProducts(res.data || []))
      .catch(console.error);

    axios.get(`${MASTER_API}/configuration/category`, { headers: authHeaders() })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setCategoryOptions(data);
      }).catch(console.error);

    axios.get(`${MASTER_API}/configuration/sub-category`, { headers: authHeaders() })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setSubCategoryOptions(data);
      }).catch(console.error);

    // Goods Receipt is the "Internal" side (same as Purchase Requisition /
    // Purchase Order) — only Product Types tagged Internal in Product
    // Master should appear here. Previously called with no usage filter,
    // so External-tagged types (Semi Finished, Finished Goods) showed up
    // here too.
    axios.get(`${MASTER_API}/configuration/product-types?usage=Internal`, { headers: authHeaders() })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setProductTypeOptions(data.map(i => ({ value: i.name || i, label: i.name || i })));
      }).catch(console.error);
  }, []);

  useEffect(() => {
    axios.get(`${MASTER_API}/configuration/purchase-orgs`, { headers: authHeaders() })
      .then(res => setManualPurchaseOrgs(res.data?.data || []));

    axios.get(`${MASTER_API}/configuration/purchase-planners`, { headers: authHeaders() })
      .then(res => setManualPurchasePlanners(res.data?.data || []));

    axios.get(`${MASTER_API}/configuration/location`, { headers: authHeaders() })
      .then(res => setManualLocations(res.data || []));

    axios.get(`${MASTER_API}/business-partner/list`, { headers: authHeaders() })
      .then((res) => { setVendorList(res.data?.data || []); })
      .catch(console.error);


    axios.get(`${MASTER_API}/configuration/dynamic/mode_of_transport`, { headers: authHeaders() })
      .then(res => setModeOfTransports(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/delivery_type`, { headers: authHeaders() })
      .then(res => setDeliveryTypes(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/freight_terms`, { headers: authHeaders() })
      .then(res => setFreightTerms(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/insurance_terms`, { headers: authHeaders() })
      .then(res => setInsuranceTerms(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/transporter`, { headers: authHeaders() })
      .then(res => setTransporters(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/purchase_type`, { headers: authHeaders() })
      .then(res => setPurchaseTypes(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/state_grouping`, { headers: authHeaders() })
      .then(res => setStateGroupings(res.data || []));

    axios.get(`${MASTER_API}/configuration/dynamic/po_header_lot_type`, { headers: authHeaders() })
      .then(res => setPoHeaderLotTypes(res.data || []));

    axios
      .get(`${PURCHASE_API}/goods-receipt/grn-storage-locations`, { headers: authHeaders() })
      .then(res => setStorageLocations(res.data || []))
      .catch(console.error);
  }, []);

  const viewPO = (poNo) => {
    setIsManualGRN(false);
    setGrnPdfBlob(null);
    axios.get(`${PURCHASE_API}/goods-receipt/view/po/${poNo}`, { headers: authHeaders() })
      .then(async (res) => {
        // In viewPO, change the poRows mapping:
        const poRows = (res.data || []).map(r => ({
          ...r,
          open_po_qty: r.open_po,
          characteristics: Array.isArray(r.characteristics)
            ? r.characteristics
            : (() => { try { return JSON.parse(r.characteristics || "[]"); } catch { return []; } })(),
          // ✅ ADD THESE - initialize basic tab fields (will be blank for new GRN from PO)
          mode_of_transport: r.mode_of_transport || "",
          delivery_type: r.delivery_type || "",
          freight_terms: r.freight_terms || "",
          insurance_terms: r.insurance_terms || "",
          transporter: r.transporter || "",
          purchase_type: r.purchase_type || "",
          state_grouping: r.state_grouping || "",
          po_header_lot_type: r.po_header_lot_type || "",
          product_type: r.product_type || r.productType || "",
          storage_location: r.storage_location || getDefaultStorageLocation().storage_location,
          storage_code: r.storage_code || getDefaultStorageLocation().storage_code,
        }));

        setModalData(poRows);
        // GRN number is NEVER taken from PO — it is auto-generated by the backend on save
        setGeneratedGRN("");
        setGrnPdfBlob(null);
        setReceivedData({});
        setBatchData({});
        setInvoiceNo("");
        setCreateActiveTab("basic");
        setIsEditMode(false);
        setShowModal(true);

        const pTerms = poRows[0]?.payment_terms || "";
        if (pTerms) {
          setPaymentTermNumber(String(pTerms));
          setPaymentTermUnit("");
        } else {
          setPaymentTermNumber("");
          setPaymentTermUnit("");
        }
      })
      .catch(err => console.error(err));
  };

  // ── Shared jsPDF builder — no html2canvas, no html2pdf, never blank ──────────
  const buildGRNPdf = async (rows, grnNumber, supplier, filename) => {
    const toBase64 = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          try {
            const c = document.createElement("canvas");
            c.width = img.naturalWidth || 400; c.height = img.naturalHeight || 120;
            c.getContext("2d").drawImage(img, 0, 0);
            resolve(c.toDataURL("image/png"));
          } catch { resolve(null); }
        };
        img.onerror = () => resolve(null);
        img.src = src.startsWith("data:") ? src : src + "?cb=" + Date.now();
      });

    // ── Layout below is kept byte-for-byte identical to GoodsReceiptView.js's
    // buildAndSavePDF so the downloaded file always matches the "View" modal. ──
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const PW = 210, ML = 12, MR = 12, CW = PW - ML - MR;
    let y = 12;

    const guard = (n = 10) => { if (y + n > 282) { pdf.addPage(); y = 12; } };
    const hline = (x1, y1, x2, y2) => { pdf.setDrawColor(0); pdf.line(x1, y1, x2, y2); };
    const box = (x, by, w, h) => { pdf.setDrawColor(0); pdf.rect(x, by, w, h); };

    // Header meta
    const revisionDateStr = rows[0]?.revision_date
      ? new Date(rows[0].revision_date).toLocaleDateString()
      : "";
    pdf.setFontSize(9); pdf.setFont("helvetica", "bold");
    pdf.text(`Format No. ${rows[0]?.format_no ?? ""}`, ML, y);
    pdf.text(`Revision Date : ${revisionDateStr}`, PW - MR, y, { align: "right" });
    y += 7;

    // Logo
    const logoB64 = await toBase64(sbeeLogo);
    if (logoB64) {
      const lw = 48; pdf.addImage(logoB64, "PNG", (PW - lw) / 2, y, lw, 14); y += 18;
    } else {
      pdf.setFontSize(18); pdf.setFont("helvetica", "bold");
      pdf.text("SBEE", PW / 2, y + 8, { align: "center" }); y += 14;
    }

    // Title
    pdf.setFontSize(15); pdf.setFont("helvetica", "bold");
    pdf.text("GOODS RECEIPT", PW / 2, y, { align: "center" }); y += 9;

    // Info block
    const recvDate = rows[0]?.received_date
      ? new Date(rows[0].received_date).toLocaleDateString() : "";
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "bold"); pdf.text("GRN NO :", ML, y);
    pdf.setFont("helvetica", "normal"); pdf.text(String(rows[0]?.grn_number ?? ""), ML + 22, y);
    pdf.setFont("helvetica", "bold"); pdf.text("DATE :", ML, y + 6);
    pdf.setFont("helvetica", "normal"); pdf.text(recvDate, ML + 22, y + 6);

    const rx = PW / 2 + 5;
    pdf.setFont("helvetica", "bold"); pdf.text("SUPPLIER NAME :", rx, y);
    pdf.setFont("helvetica", "normal"); pdf.text(String(rows[0]?.vendor_name ?? ""), rx + 36, y);
    pdf.setFont("helvetica", "bold"); pdf.text("INVOICE NO :", rx, y + 6);
    pdf.setFont("helvetica", "normal"); pdf.text(String(rows[0]?.invoice_no ?? ""), rx + 28, y + 6);
    pdf.setFont("helvetica", "bold"); pdf.text("DATE :", rx, y + 12);
    y += 18;

    // Table
    const cols = [
      { label: "Sl No", w: 10 },
      { label: "Product Code", w: 25 },
      { label: "Material Description", w: 45 },
      { label: "UOM", w: 15 },
      { label: "Qty Ordered", w: 18 },
      { label: "Qty Received", w: 18 },
      { label: "Accepted", w: 18 },
      { label: "Rejected", w: 15 },
      { label: "Remarks", w: CW - 10 - 25 - 45 - 15 - 18 - 18 - 18 - 15 },
    ];
    const HH = 9, RH = 8;
    pdf.setFillColor(230, 230, 230); pdf.rect(ML, y, CW, HH, "FD");
    pdf.setFontSize(8.5); pdf.setFont("helvetica", "bold");
    let cx = ML;
    cols.forEach(col => {
      if (cx > ML) hline(cx, y, cx, y + HH);
      pdf.text(col.label, cx + col.w / 2, y + 5.8, { align: "center" });
      cx += col.w;
    });
    y += HH;
    pdf.setFont("helvetica", "normal"); pdf.setFontSize(9);
    rows.forEach((item, idx) => {
      guard(RH); box(ML, y, CW, RH);
      const cells = [
        { val: idx + 1, align: "center" },
        { val: item.product_code, align: "center" },
        { val: item.description, align: "left" },
        { val: item.uom, align: "center" },
        { val: item.requirement_qty, align: "center" },
        { val: item.received_qty, align: "center" },
        { val: item.received_qty, align: "center" },
        { val: 0, align: "center" },
        { val: item.status, align: "center" },
      ];
      cx = ML;
      cols.forEach((col, ci) => {
        if (cx > ML) hline(cx, y, cx, y + RH);
        const c = cells[ci]; const v = String(c.val ?? "");
        const tx = c.align === "center" ? cx + col.w / 2 : cx + 2;
        pdf.text((pdf.splitTextToSize(v, col.w - 3)[0] ?? ""), tx, y + 5.2, { align: c.align });
        cx += col.w;
      });
      y += RH;
    });

    // Footer
    y += 4; guard(44); box(ML, y, CW, 44);
    pdf.setFontSize(10); pdf.setFont("helvetica", "bold");
    pdf.text("Supplier T.C. No & Dt :", ML + 3, y + 7);
    pdf.setFont("helvetica", "normal");
    pdf.text(String(supplier?.terms_and_conditions ?? ""), ML + 50, y + 7);
    pdf.setFont("helvetica", "bold"); pdf.text("Status :", ML + 3, y + 14);
    pdf.setFont("helvetica", "normal"); pdf.text(String(rows[0]?.status ?? ""), ML + 20, y + 14);
    pdf.setFont("helvetica", "bold");
    pdf.text("Prepared By", ML + 15, y + 32, { align: "center" });
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(8);
    pdf.text(String(rows[0]?.created_by ?? "").split("@")[0], ML + 15, y + 37, { align: "center" });
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.text("Received By", PW / 2, y + 39, { align: "center" });
    pdf.text("Checked By", PW - MR - 15, y + 39, { align: "center" });

    pdf.save(filename);
  };

  const handleDownloadGRN = async (grnNumber) => {
    try {
      const res = await axios.get(`${PURCHASE_API}/goods-receipt/view/by-grn/${grnNumber}`, { headers: authHeaders() });
      const rows = res.data || [];
      if (!rows.length) { alert("No GRN data found."); return; }

      let supplier = null;
      try {
        const sRes = await axios.get(`${MASTER_API}/business-partner/all`, { headers: authHeaders() });
        supplier = (sRes.data?.data || []).find(
          x => x.business_partner_name === rows[0]?.vendor_name
        ) || null;
      } catch (_) { }

      await buildGRNPdf(rows, grnNumber, supplier, `${grnNumber}_GoodsReceipt.pdf`);
    } catch (err) {
      console.error("PDF error:", err);
      alert("PDF error: " + err.message);
    }
  };

  const viewGRN = (grnNo) => {
    setIsManualGRN(false);
    setGrnPdfBlob(null);
    setShowGrnViewModal(false);

    axios
      .get(`${PURCHASE_API}/goods-receipt/view/by-grn/${grnNo}`, { headers: authHeaders() })
      .then((res) => {

        console.log("VIEW GRN DATA =", res.data);

        const poRows = (res.data || []).map((r) => ({
          ...r,

          delivery_date: r.delivery_date || r.deliver_date || "",

          supplier_batches:
            typeof r.supplier_batches === "string"
              ? JSON.parse(r.supplier_batches || "[]")
              : (r.supplier_batches || []),

          storage_location: r.storage_location || "",
          storage_code: r.storage_code || "",

          characteristics: Array.isArray(r.characteristics)
            ? r.characteristics
            : (() => {
              try {
                return JSON.parse(r.characteristics || "[]");
              } catch {
                return [];
              }
            })(),

          mode_of_transport: r.mode_of_transport || "",
          delivery_type: r.delivery_type || "",
          freight_terms: r.freight_terms || "",
          insurance_terms: r.insurance_terms || "",
          transporter: r.transporter || "",
          purchase_type: r.purchase_type || "",
          state_grouping: r.state_grouping || "",
          po_header_lot_type: r.po_header_lot_type || "",
        }));

        console.log("MAPPED DATA =", poRows);

        setModalData(poRows);
        setGeneratedGRN(poRows[0]?.grn_number || grnNo);

        // Posted GRN already has real received_qty/received_date saved on each row —
        // show them instead of blanking the field out.
        const seededReceived = {};
        poRows.forEach((r, idx) => {
          seededReceived[idx] = {
            received_qty: r.received_qty ?? "",
            received_date: r.received_date
              ? String(r.received_date).split("T")[0]
              : ""
          };
        });
        setReceivedData(seededReceived);

        setBatchData({});
        setCreateActiveTab("basic");
        setIsEditMode(false);
        setShowModal(true);

        const pTerms = poRows[0]?.payment_terms || "";

        if (pTerms) {
          setPaymentTermNumber(String(pTerms));
          setPaymentTermUnit("");
        } else {
          setPaymentTermNumber("");
          setPaymentTermUnit("");
        }

        setInvoiceNo(poRows[0]?.invoice_no || "");

        const grnNum = poRows[0]?.grn_number || grnNo;

        setGrnPdfBlob({
          url: `/goods-receipt-view/${grnNum}?action=download`,
          filename: `${grnNum}_GoodsReceipt.pdf`,
          grnNo: grnNum,
        });
      })
      .catch((err) => {
        console.error("VIEW GRN ERROR", err);
      });
  };
  //eslint-disable-next-line
  const buildGRNHtml = (rows, grnNumber, supplierInfo) => {
    const receivedDate = rows[0]?.received_date
      ? formatDateDMY(rows[0].received_date)
      : formatDateDMY(getTodayLocal());
    const itemRows = rows.map((item, index) => `
      <tr>
        <td style="border:1px solid black;padding:8px;text-align:center;font-size:13px;">${index + 1}</td>
        <td style="border:1px solid black;padding:8px;text-align:left;font-size:13px;">${item.description || ""}</td>
        <td style="border:1px solid black;padding:8px;text-align:center;font-size:13px;">${item.requirement_qty || ""}</td>
        <td style="border:1px solid black;padding:8px;text-align:center;font-size:13px;">${item.received_qty || ""}</td>
        <td style="border:1px solid black;padding:8px;text-align:center;font-size:13px;">${item.received_qty || ""}</td>
        <td style="border:1px solid black;padding:8px;text-align:center;font-size:13px;">0</td>
        <td style="border:1px solid black;padding:8px;text-align:center;font-size:13px;">${item.status || "POSTED"}</td>
      </tr>`).join("");
    return `
      <div style="width:960px;margin:0 auto;border:1px solid black;padding:15px;font-family:Calibri,sans-serif;background:#fff;">
        <div style="display:flex;justify-content:space-between;margin-bottom:15px;font-size:13px;font-weight:bold;">
          <span>Format No. STRs / F.01</span>
          <span>Revision No. &amp; Date : 01 &amp; 01/04/2009</span>
        </div>
        <div style="text-align:center;margin-bottom:15px;">
          <img src="${sbeeLogo}" alt="SBEE" style="width:220px;height:auto;" crossorigin="anonymous" />
        </div>
        <h3 style="text-align:center;margin-top:5px;margin-bottom:20px;font-size:22px;font-weight:bold;">GOODS RECEIPT</h3>
        <div style="display:flex;justify-content:space-between;margin-bottom:20px;">
          <div>
            <p style="margin:4px 0;"><b>GRN NO :</b> ${grnNumber}</p>
            <p style="margin:4px 0;"><b>DATE :</b> ${receivedDate}</p>
          </div>
          <div>
            <p style="margin:4px 0;"><b>SUPPLIER NAME :</b> ${rows[0]?.vendor_name || ""}</p>
            <p style="margin:4px 0;"><b>INVOICE NO :</b></p>
            <p style="margin:4px 0;"><b>DATE :</b></p>
          </div>
        </div>
        <table style="width:100%;border-collapse:collapse;">
          <thead>
            <tr>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Sl No</th>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Material Description</th>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Qty Ordered</th>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Qty Received</th>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Accepted</th>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Rejected</th>
              <th style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;font-size:13px;">Remarks</th>
            </tr>
          </thead>
          <tbody>${itemRows}</tbody>
        </table>
        <div style="margin-top:20px;border:1px solid black;padding:10px;">
          <p style="margin:4px 0;"><b>Supplier T.C. No &amp; Dt :</b> ${supplierInfo?.terms_and_conditions || ""}</p>
          <p style="margin:4px 0;"><b>Status :</b> POSTED</p>
          <div style="display:flex;justify-content:space-between;margin-top:60px;">
            <div><b>Prepared By</b></div>
            <div><b>Received By</b></div>
            <div><b>Checked By</b></div>
          </div>
        </div>
      </div>`;
  };

  // classSource: "supplier" → Supplier Data icon, shows only Supplier Description.
  // Omitted → shows everything (legacy/fallback behaviour).
  const handleOpenCharModal = (index, row, classSource) => {
    setModalIndex(index);
    setModalVisible(true);

    let chars = row.characteristics || row.Characteristics || [];

    // Handle double-stringified JSON
    if (typeof chars === 'string') {
      try { chars = JSON.parse(chars); } catch { chars = []; }
    }

    // If still a string after first parse (double-encoded)
    if (typeof chars === 'string') {
      try { chars = JSON.parse(chars); } catch { chars = []; }
    }

    if (!Array.isArray(chars)) { chars = []; }

    // Filter out empty/invalid entries
    let charData = chars
      .filter(c => c && (c.characteristic || c.name))
      .map(c => ({
        characteristic: c.characteristic || c.name || "",
        value: c.value || ""
      }));

    const normalize = (s) => (s || "").trim().toLowerCase();

    if (classSource === "supplier") {
      // Only Supplier Description from the Product Class.
      charData = charData.filter((c) => normalize(c.characteristic) === "supplier description");
    }

    console.log("CHAR DEBUG - raw:", row.characteristics);
    console.log("CHAR DEBUG - parsed:", charData);

    setSelectedCharacteristics(charData);
  };

  const handleSaveCharModal = (newChars) => {
    const updatedData = [...modalData];
    if (updatedData[modalIndex]) {
      // Merge back into the row's full characteristics list instead of
      // overwriting it, so saving from a filtered view (Supplier Data's
      // Supplier Description) doesn't wipe out the row's other characteristics
      // (e.g. Over Tolerance).
      const existingChars = updatedData[modalIndex].characteristics || [];
      const editedNames = new Set(
        (newChars || []).map(c => (c.characteristic || "").trim().toLowerCase())
      );
      const untouched = existingChars.filter(
        c => !editedNames.has((c.characteristic || c.name || "").trim().toLowerCase())
      );
      updatedData[modalIndex] = {
        ...updatedData[modalIndex],
        characteristics: [...untouched, ...(newChars || [])]
      };
      setModalData(updatedData);
    }
    setModalVisible(false);
  };

  // GRN document upload size limit — fetched from Configuration → File Size
  // Config (Module = "Goods Receipt"). Same pattern as SalesOrder.js /
  // PurchaseOrder.js — keep all three in sync.
  useEffect(() => {
    fetch(`${MASTER_API}/configuration/file-size-limit/${encodeURIComponent("Goods Receipt")}`)
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => {
        if (data && data.maxSizeKb) setMaxGrnDocSizeKb(data.maxSizeKb);
      })
      .catch(() => { /* keep default limit if config fetch fails */ });
  }, []);

  // Splits a FileList/array into files within the limit and files that
  // exceed it, and toasts a warning listing any rejected files.
  const filterGrnFilesWithinSizeLimit = (files) => {
    const maxBytes = maxGrnDocSizeKb * 1024;
    const okFiles = [];
    const rejected = [];
    files.forEach(f => {
      if (f.size > maxBytes) {
        rejected.push(f.name);
      } else {
        okFiles.push(f);
      }
    });
    if (rejected.length) {
      toast.error(
        `${rejected.length} file(s) exceed the ${maxGrnDocSizeKb} KB upload limit and were skipped: ${rejected.join(', ')}`
      );
    }
    return okFiles;
  };

  // Pulls the server-side (Google Drive-backed) docs list for an existing
  // GRN — mirrors PurchaseRequisition.js's fetchUploadedDocs.
  const fetchUploadedDocs = (grnNo) => {
    if (!grnNo) { setUploadedDocs([]); return; }
    axios.get(`${PURCHASE_API}/goods-receipt/list-docs/${encodeURIComponent(grnNo)}`, { headers: authHeaders() })
      .then(res => setUploadedDocs(res.data?.files || []))
      .catch(() => setUploadedDocs([]));
  };

  // Docs tab file picker. Once the GRN already has a number (generatedGRN),
  // files upload straight to Drive via upload-docs/:grnNo, same as PR. For a
  // brand-new, not-yet-saved GRN there's no grn_number to upload against
  // yet, so files are staged locally instead and sent along with the
  // Save/Short Close request (see handleSaveGRN / handleShortClose).
  const handleGrnDocUpload = async (e) => {
    const rawFiles = Array.from(e.target.files);
    e.target.value = ""; // allow re-selecting the same file name later

    const okFiles = filterGrnFilesWithinSizeLimit(rawFiles);
    if (!okFiles.length) return;

    if (!generatedGRN) {
      setUploadedGrnDocs(prev => [...prev, ...okFiles]);
      return;
    }

    const formData = new FormData();
    okFiles.forEach((f) => formData.append("docs", f));

    setDocsUploading(true);
    try {
      await axios.post(
        `${PURCHASE_API}/goods-receipt/upload-docs/${encodeURIComponent(generatedGRN)}`,
        formData,
        { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } }
      );
      fetchUploadedDocs(generatedGRN);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to upload document(s)");
    } finally {
      setDocsUploading(false);
    }
  };

  const handleRemoveGrnDoc = (indexToRemove) => {
    setUploadedGrnDocs(prev => prev.filter((_, i) => i !== indexToRemove));
  };

  // Downloads a doc already on Drive — mirrors PurchaseRequisition.js's
  // handleDocDownload.
  const handleDocDownload = async (doc) => {
    if (!generatedGRN || !doc.filename) return;
    try {
      const res = await fetch(
        `${PURCHASE_API}/goods-receipt/download-doc/${encodeURIComponent(generatedGRN)}/${encodeURIComponent(doc.filename)}`,
        { headers: authHeaders() }
      );
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || `Download failed (${res.status})`);
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = doc.originalname || doc.filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(err.message || "Failed to download file");
    }
  };

  // Fetch the persisted docs list from the server whenever the Docs tab is
  // opened on a GRN that already has a number — mirrors
  // PurchaseRequisition.js's equivalent effect.
  useEffect(() => {
    if (createActiveTab === "docs" && generatedGRN) {
      fetchUploadedDocs(generatedGRN);
    }
    //eslint-disable-next-line
  }, [createActiveTab, generatedGRN]);

  // Characteristics can arrive as an array, a JSON string, or a
  // double-encoded JSON string — normalise to an array.
  const parseRowChars = (row) => {
    let chars = row?.characteristics || row?.Characteristics || [];
    if (typeof chars === "string") {
      try { chars = JSON.parse(chars); } catch { chars = []; }
    }
    if (typeof chars === "string") {
      try { chars = JSON.parse(chars); } catch { chars = []; }
    }
    return Array.isArray(chars) ? chars : [];
  };

  const isOverTolChar = (c) =>
    (c?.characteristic || c?.name || "").trim().toLowerCase().replace(/\s+/g, "") === "overtolerance";

  const getOverTolerance = (row) => {
    const c = parseRowChars(row).find(isOverTolChar);
    return c?.value ?? "";
  };

  const handleOverToleranceChange = (idx, rawValue) => {
    // digits + a single decimal point only
    const clean = String(rawValue).replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    setModalData((prev) => {
      const next = [...prev];
      const chars = [...parseRowChars(next[idx])];
      const ci = chars.findIndex(isOverTolChar);
      if (ci >= 0) chars[ci] = { ...chars[ci], value: clean };
      else chars.push({ characteristic: "Over Tolerance", value: clean });
      next[idx] = { ...next[idx], characteristics: chars };
      return next;
    });
  };

  // Over Tolerance range = Qty + Over Tolerance %. The % is typed straight
  // into the "Over Tolerance (%)" column (Purchase Class / Under Tolerance
  // are no longer part of this screen). Anchored to the ordered Qty
  // (row.requirement_qty) so the range stays fixed and doesn't shift as
  // Received Qty is typed; when there's no ordered qty (e.g. a manual GRN
  // line) it falls back to the Received Qty typed on that row.
  const getToleranceRange = (row, idx) => {
    const baseQty = Number(row.requirement_qty);
    const qty =
      baseQty > 0
        ? baseQty
        : Number(receivedData[idx]?.received_qty) || 0;

    const overRaw = getOverTolerance(row);
    const overPct = Number(overRaw);
    const hasOver = overRaw !== "" && !isNaN(overPct);

    if (!qty || !hasOver) {
      return { rangeMin: null, rangeMax: null, rangeText: "" };
    }

    const rangeMax = qty + (qty * overPct) / 100;

    return {
      rangeMin: null,
      rangeMax,
      rangeText: `≤ ${rangeMax.toFixed(2)}`
    };
  };

  // Open PO qty — this is just the actual open/ordered qty for the line,
  // NOT the tolerance Range. (Previously this was bumped up to match the
  // Range's max whenever that was higher, which made the Open PO column
  // show the same value as Range — that's wrong; Open PO must always
  // reflect the real open PO quantity.)
  const getEffectiveOpenPo = (row) => {
    return Number(
      row.open_po_qty !== undefined && row.open_po_qty !== null && row.open_po_qty !== ""
        ? row.open_po_qty
        : row.requirement_qty ?? 0
    );
  };

  // Received Qty ceiling for validation — allow it to run up to the Over
  // Tolerance Range (e.g. Qty 100 / Range ≤106 → 106 is a valid Received
  // Qty), not just the Open PO qty. Falls back to Open PO qty when the row
  // has no tolerance characteristic (rangeMax is null).
  const getReceivedQtyCeiling = (row) => {
    const { rangeMax } = getToleranceRange(row);
    const openPo = getEffectiveOpenPo(row);
    return rangeMax !== null && !isNaN(rangeMax) ? Math.max(rangeMax, openPo) : openPo;
  };
  //eslint-disable-next-line
  const handleViewProductDetails = (row) => {
    setProductDetails({
      product_code: row.product_code,
      hsnCode: row.hsn_code,
      requirement_qty: row.requirement_qty,
      product_cost: row.product_cost,
      discount: row.discount || 0,
      netPriceAfterDiscount: row.net_price_after_discount,
      cgst: row.cgst_percent,
      sgst: row.sgst_percent,
      igst: row.igst_percent,
      cgstAmount: row.cgst_amount,
      sgstAmount: row.sgst_amount,
      igstAmount: row.igst_amount,
      totalCost: row.total_cost,
      totalGST: row.total_gst_amount,
      finalPriceAfterGST: row.final_price_after_gst,
    });
    setShowProductModal(true);
  };

  const handleSaveGRN = async () => {
    if (!modalData || modalData.length === 0) {
      toast.error("No items selected for GRN");
      return;
    }

    // A PO-based GRN can only be posted once a Gate Pass referencing this PO
    // exists. Manual GRNs (no purchase_order_id) are not affected.
    const poNoForCheck = modalData[0]?.purchase_order_id;
    if (poNoForCheck && !modalData[0]?.gate_pass_no) {
      toast.error(`Cannot POST GRN: no Gate Pass found for PO ${poNoForCheck}. Please create a Gate Pass referencing this PO first.`);
      return;
    }

    const vendorNames = [...new Set(modalData.map(r => r.vendor_name || r._pirVendorName).filter(Boolean))];
    if (vendorNames.length > 1) {
      toast.error(`Cannot POST GRN: Products belong to different vendors (${vendorNames.join(", ")}). A GRN must have a single vendor.`);
      return;
    }

    if (!invoiceNo || !invoiceNo.trim()) {
      toast.error("Please enter an Invoice No before posting the GRN.");
      return;
    }

    // Storage Location validation:
    // Not compulsory for every row — same as Received Qty, at least one
    // product row must have a Storage Location selected before posting.
    const hasAnyStorageLocation = modalData.some(row => !!row.storage_location);
    if (!hasAnyStorageLocation) {
      toast.error("Please select a Storage Location for at least one product before posting.");
      return;
    }

    // Received Qty validation:
    // 1) At least one product row must have a Received Qty entered.
    // 2) A Received Qty of 0 is never valid — either leave it blank or enter 1 or more.
    const zeroQtyEntered = modalData.some((row, idx) => {
      const raw = receivedData[idx]?.received_qty;
      return raw !== undefined && raw !== null && String(raw).trim() !== "" && Number(raw) <= 0;
    });
    if (zeroQtyEntered) {
      toast.error("Received Qty cannot be 0. Enter a quantity of 1 or more, or leave it blank.");
      return;
    }

    const hasAnyReceivedQty = modalData.some((row, idx) => Number(receivedData[idx]?.received_qty || 0) > 0);
    if (!hasAnyReceivedQty) {
      toast.error("Please enter a Received Qty (1 or more) for at least one product before posting.");
      return;
    }

    // RECEIVED QTY MUST NOT EXCEED THE TOLERANCE RANGE (falls back to the
    // Open PO / ordered qty when a row has no Over Tolerance set).
    // No lower bound (any qty above 0 is fine) — only block going over the
    // ceiling. Manual GRN is explicitly exempt: there's no PO to stay
    // within, and Received Qty is allowed to run past the Range shown for
    // the line — same rule the backend's manual-GRN branch already follows
    // (see Goodsreceipt_service.js, "BRANCH: MANUAL GRN", which never
    // applies an open-PO/totalOpen cap).
    if (!isManualGRN) {
      for (let idx = 0; idx < modalData.length; idx++) {
        const row = modalData[idx];
        const receivedQtyRaw = receivedData[idx]?.received_qty;
        if (receivedQtyRaw === undefined || receivedQtyRaw === null || String(receivedQtyRaw).trim() === "") continue;

        const enteredQty = Number(receivedQtyRaw);
        const maxQty = getReceivedQtyCeiling(row);

        if (!isNaN(maxQty) && maxQty > 0 && enteredQty > maxQty) {
          toast.error(
            `Received Qty for ${row.product_code || `Row ${idx + 1}`} cannot be more than ${maxQty}.`
          );
          return;
        }
      }
    }

    const payloadRows = modalData.map((row, idx) => {
      const prevOpenPO = getEffectiveOpenPo(row);

      // 🆕 Persist the Over Tolerance range alongside the line, same
      // as Purchase Order does, so it's recorded against this GRN too.
      const { rangeMin, rangeMax } = getToleranceRange(row, idx);

      return {
        product_code: row.product_code,
        storage_location: row.storage_location || "",
        storage_code: row.storage_code || "",
        supplier_batches: row.supplier_batches || [],
        characteristics: row.characteristics || [],
        batchCharacteristics: row.batchCharacteristics || [],
        description: row.description,
        purchase_request_no: row.purchase_request_no,
        uom: row.uom,
        hsn_code: row.hsn_code,
        requirement_qty: row.requirement_qty,
        range_min: rangeMin,
        range_max: rangeMax,
        open_po_qty: isManualGRN
          ? Math.max(Number(row.requirement_qty || 0) - Number(receivedData[idx]?.received_qty || 0), 0)
          : Math.max(prevOpenPO - Number(receivedData[idx]?.received_qty || 0), 0),
        requirement_date: row.requirement_date ? formatDate(row.requirement_date) : null,
        product_cost: row.product_cost,
        product_class: row.product_class || "",
        currency: row.currency || "",
        delivery_date: row.delivery_date ? formatDate(row.delivery_date) : null,
        discount: row.discount,
        total_cost: row.total_cost,
        net_price_after_discount: row.net_price_after_discount,
        cgst_percent: row.cgst_percent,
        sgst_percent: row.sgst_percent,
        igst_percent: row.igst_percent,
        cgst_amount: row.cgst_amount,
        sgst_amount: row.sgst_amount,
        igst_amount: row.igst_amount,
        total_gst_amount: row.total_gst_amount,
        final_price_after_gst: row.final_price_after_gst,
        purchase_organization: modalData?.[0]?.purchase_organization,
        purchase_planner: modalData?.[0]?.purchase_planner,
        location: modalData?.[0]?.location,
        vendor_name: modalData?.[0]?.vendor_name,
        product_type: modalData?.[0]?.product_type || "",
        // Header-level Order Type ("Goods"/"Service"), Manual GRN only —
        // service lines skip the stock table entirely on the backend.
        order_type: modalData?.[0]?.order_type || "",
        mode_of_transport: modalData?.[0]?.mode_of_transport || "",
        delivery_type: modalData?.[0]?.delivery_type || "",
        freight_terms: modalData?.[0]?.freight_terms || "",
        insurance_terms: modalData?.[0]?.insurance_terms || "",
        transporter: modalData?.[0]?.transporter || "",
        purchase_type: modalData?.[0]?.purchase_type || "",
        state_grouping: modalData?.[0]?.state_grouping || "",
        po_header_lot_type: modalData?.[0]?.po_header_lot_type || "",
        batch_number: batchData[idx] || null,
        received_qty: receivedData[idx]?.received_qty || 0,
        received_date: receivedData[idx]?.received_date
          ? formatDate(receivedData[idx].received_date)
          : today
      };
    });

    console.log("ALL localStorage:", { ...localStorage });
    console.log("createdBy:", createdBy);

    const formData = new FormData();
    formData.append("isManualGRN", isManualGRN);
    formData.append("purchase_order_id", modalData?.[0]?.purchase_order_id);
    formData.append("purchase_request_no", modalData?.[0]?.purchase_request_no || "");
    formData.append("payment_terms", paymentTermNumber || "");
    formData.append("invoice_no", invoiceNo || "");
    formData.append("created_by", createdBy);   // ← ADD THIS LINE
    formData.append("rows", JSON.stringify(payloadRows));
    // Staged Docs-tab files (only present if the user attached some before
    // this GRN had a number) — sent together, matches upload.array("invoice", 20)
    // on the server.
    uploadedGrnDocs.forEach((f) => formData.append("invoice", f));

    try {
      const url = `${PURCHASE_API}/goods-receipt/save`;
      const res = await axios.post(url, formData, {
        headers: { ...authHeaders(), "Content-Type": "multipart/form-data" }
      });

      if (res.data.success) {
        const newGrnNumber = res.data.grn_number;
        toast.success(`GRN ${newGrnNumber} created successfully`);

        // Freeze this GRN's actual raw-material cost into Product Costing.
        // Only for a GRN posted against a real Purchase Order -- manual
        // GRNs have no purchase_order_id and no planned cost to compare
        // against, so there's nothing to snapshot. Fire-and-forget: a
        // failure here shouldn't block the GRN itself from being posted.
        if (!isManualGRN && modalData?.[0]?.purchase_order_id) {
          axios
            .post(
              `${PURCHASE_API}/product-costing/calculate-actual-raw-material-cost`,
              {
                purchaseOrderNumber: modalData[0].purchase_order_id,
                grnNumber: newGrnNumber,
              },
              { headers: authHeaders() }
            )
            .catch((err) => {
              console.error("calculate-actual-raw-material-cost error:", err);
            });
        }

        let supplierInfo = null;
        try {
          const bpRes = await axios.get(`${MASTER_API}/business-partner/all`, { headers: authHeaders() });
          //eslint-disable-next-line
          supplierInfo = (bpRes.data?.data || []).find(
            (x) => x.business_partner_name === modalData[0]?.vendor_name
          );
        } catch (_) { }
        //eslint-disable-next-line
        const enrichedRows = payloadRows.map((r) => ({
          ...r,
          status: "POSTED",
          received_date: r.received_date || today,
        }));

        const pdfFilename = `${newGrnNumber}_GoodsReceipt.pdf`;
        setGrnPdfBlob({ url: null, filename: pdfFilename, grnNo: newGrnNumber });

        setBatchData({});
        setReceivedData({});
        setUploadedGrnDocs([]);
        // invoiceNo intentionally kept — stays visible after posting
        setGeneratedGRN(newGrnNumber);
        setIsEditMode(false);
        setIsManualGRN(false);
        setActiveTab("posted");
        setCreateActiveTab("docs");
        setShowModal(true);

        axios.get(`${PURCHASE_API}/goods-receipt/list`, { headers: authHeaders(), params: { ...filters, tab: "posted" } }).then(res => setGrnList(res.data || []));

      } else {
        toast.error("Error: " + (res.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Save GRN Error:", error);
      const serverMsg = error.response?.data?.message || error.message;
      toast.error(`Failed to save GRN: ${serverMsg}`);
    }
  };

  // ============================
  // SHORT CLOSE GRN
  // Posts the GRN with whatever was actually received this time — which can
  // be partial, or zero on every line — and force-closes the remaining Open
  // PO qty to 0 on every row instead of carrying it forward for a future
  // partial receipt. Same success path as POST GRN (moves to the Posted
  // tab), but the PO line(s) are treated as fully settled: nothing further
  // is expected against them. Unlike POST GRN, this does NOT require at
  // least one row to have a Received Qty entered — short-closing a line
  // with nothing received at all is the whole point.
  // ============================
  const handleShortCloseGRN = async () => {
    if (!modalData || modalData.length === 0) {
      toast.error("No items selected for GRN");
      return;
    }

    const poNoForCheck = modalData[0]?.purchase_order_id;
    if (poNoForCheck && !modalData[0]?.gate_pass_no) {
      toast.error(`Cannot Short Close: no Gate Pass found for PO ${poNoForCheck}. Please create a Gate Pass referencing this PO first.`);
      return;
    }

    const vendorNames = [...new Set(modalData.map(r => r.vendor_name || r._pirVendorName).filter(Boolean))];
    if (vendorNames.length > 1) {
      toast.error(`Cannot Short Close: Products belong to different vendors (${vendorNames.join(", ")}). A GRN must have a single vendor.`);
      return;
    }

    if (!invoiceNo || !invoiceNo.trim()) {
      toast.error("Please enter an Invoice No before short closing the GRN.");
      return;
    }

    // A Received Qty of 0 is still never valid for a row where something was
    // actually typed in — same rule as POST GRN. Short Close just doesn't
    // REQUIRE any row to have a qty at all (leave it blank to close with
    // nothing received on that line).
    const zeroQtyEntered = modalData.some((row, idx) => {
      const raw = receivedData[idx]?.received_qty;
      return raw !== undefined && raw !== null && String(raw).trim() !== "" && Number(raw) <= 0;
    });
    if (zeroQtyEntered) {
      toast.error("Received Qty cannot be 0. Enter a quantity of 1 or more, or leave it blank.");
      return;
    }

    const hasAnyReceivedQty = modalData.some((row, idx) => Number(receivedData[idx]?.received_qty || 0) > 0);
    if (hasAnyReceivedQty) {
      // Only require a Storage Location when at least one row is actually
      // receiving stock right now — a pure "close with nothing received"
      // short close has nothing to put away, so nothing to pick a location for.
      const hasAnyStorageLocation = modalData.some(row => !!row.storage_location);
      if (!hasAnyStorageLocation) {
        toast.error("Please select a Storage Location for at least one product before short closing.");
        return;
      }
    }

    // Whatever IS entered must still respect the tolerance Range ceiling
    // (falls back to Open PO qty when no Over Tolerance is set).
    // Manual GRN is exempt from this cap, same as in handlePostGRN — see
    // that comment for why (no PO to stay within; Received Qty is allowed
    // to exceed the Range shown for the line).
    if (!isManualGRN) {
      for (let idx = 0; idx < modalData.length; idx++) {
        const row = modalData[idx];
        const receivedQtyRaw = receivedData[idx]?.received_qty;
        if (receivedQtyRaw === undefined || receivedQtyRaw === null || String(receivedQtyRaw).trim() === "") continue;

        const enteredQty = Number(receivedQtyRaw);
        const maxQty = getReceivedQtyCeiling(row);

        if (!isNaN(maxQty) && maxQty > 0 && enteredQty > maxQty) {
          toast.error(
            `Received Qty for ${row.product_code || `Row ${idx + 1}`} cannot be more than ${maxQty}.`
          );
          return;
        }
      }
    }

    if (!window.confirm(
      "Short Close will mark the remaining open quantity on every line of this GRN as permanently closed — no further receipt will be expected against it. This cannot be undone. Continue?"
    )) {
      return;
    }

    const payloadRows = modalData.map((row, idx) => {
      const { rangeMin, rangeMax } = getToleranceRange(row, idx);

      return {
        product_code: row.product_code,
        storage_location: row.storage_location || "",
        storage_code: row.storage_code || "",
        supplier_batches: row.supplier_batches || [],
        characteristics: row.characteristics || [],
        batchCharacteristics: row.batchCharacteristics || [],
        description: row.description,
        purchase_request_no: row.purchase_request_no,
        uom: row.uom,
        hsn_code: row.hsn_code,
        requirement_qty: row.requirement_qty,
        range_min: rangeMin,
        range_max: rangeMax,
        // Short Close: whatever remains open on this line is forced to 0 —
        // it's being closed out now, not left pending for a future GRN.
        open_po_qty: 0,
        short_closed: true,
        requirement_date: row.requirement_date ? formatDate(row.requirement_date) : null,
        product_cost: row.product_cost,
        product_class: row.product_class || "",
        currency: row.currency || "",
        delivery_date: row.delivery_date ? formatDate(row.delivery_date) : null,
        discount: row.discount,
        total_cost: row.total_cost,
        net_price_after_discount: row.net_price_after_discount,
        cgst_percent: row.cgst_percent,
        sgst_percent: row.sgst_percent,
        igst_percent: row.igst_percent,
        cgst_amount: row.cgst_amount,
        sgst_amount: row.sgst_amount,
        igst_amount: row.igst_amount,
        total_gst_amount: row.total_gst_amount,
        final_price_after_gst: row.final_price_after_gst,
        purchase_organization: modalData?.[0]?.purchase_organization,
        purchase_planner: modalData?.[0]?.purchase_planner,
        location: modalData?.[0]?.location,
        vendor_name: modalData?.[0]?.vendor_name,
        product_type: modalData?.[0]?.product_type || "",
        mode_of_transport: modalData?.[0]?.mode_of_transport || "",
        delivery_type: modalData?.[0]?.delivery_type || "",
        freight_terms: modalData?.[0]?.freight_terms || "",
        insurance_terms: modalData?.[0]?.insurance_terms || "",
        transporter: modalData?.[0]?.transporter || "",
        purchase_type: modalData?.[0]?.purchase_type || "",
        state_grouping: modalData?.[0]?.state_grouping || "",
        po_header_lot_type: modalData?.[0]?.po_header_lot_type || "",
        batch_number: batchData[idx] || null,
        received_qty: receivedData[idx]?.received_qty || 0,
        received_date: receivedData[idx]?.received_date
          ? formatDate(receivedData[idx].received_date)
          : today
      };
    });

    const formData = new FormData();
    formData.append("isManualGRN", isManualGRN);
    formData.append("purchase_order_id", modalData?.[0]?.purchase_order_id);
    formData.append("purchase_request_no", modalData?.[0]?.purchase_request_no || "");
    formData.append("payment_terms", paymentTermNumber || "");
    formData.append("invoice_no", invoiceNo || "");
    formData.append("created_by", createdBy);
    formData.append("short_closed", "true");
    formData.append("rows", JSON.stringify(payloadRows));
    // Staged Docs-tab files (only present if the user attached some before
    // this GRN had a number) — sent together, matches upload.array("invoice", 20)
    // on the server.
    uploadedGrnDocs.forEach((f) => formData.append("invoice", f));

    try {
      const url = `${PURCHASE_API}/goods-receipt/save`;
      const res = await axios.post(url, formData, {
        headers: { ...authHeaders(), "Content-Type": "multipart/form-data" }
      });

      if (res.data.success) {
        const newGrnNumber = res.data.grn_number;
        toast.success(`GRN ${newGrnNumber} short closed successfully`);

        // Same as handleSaveGRN -- freeze actual raw-material cost for this
        // GRN, only when it's posted against a real Purchase Order.
        if (!isManualGRN && modalData?.[0]?.purchase_order_id) {
          axios
            .post(
              `${PURCHASE_API}/product-costing/calculate-actual-raw-material-cost`,
              {
                purchaseOrderNumber: modalData[0].purchase_order_id,
                grnNumber: newGrnNumber,
              },
              { headers: authHeaders() }
            )
            .catch((err) => {
              console.error("calculate-actual-raw-material-cost error:", err);
            });
        }

        const pdfFilename = `${newGrnNumber}_GoodsReceipt.pdf`;
        setGrnPdfBlob({ url: null, filename: pdfFilename, grnNo: newGrnNumber });

        setBatchData({});
        setReceivedData({});
        setUploadedGrnDocs([]);
        setGeneratedGRN(newGrnNumber);
        setIsEditMode(false);
        setIsManualGRN(false);
        setActiveTab("posted");
        setCreateActiveTab("docs");
        setShowModal(true);

        axios.get(`${PURCHASE_API}/goods-receipt/list`, { headers: authHeaders(), params: { ...filters, tab: "posted" } }).then(res => setGrnList(res.data || []));

      } else {
        toast.error("Error: " + (res.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Short Close GRN Error:", error);
      const serverMsg = error.response?.data?.message || error.message;
      toast.error(`Failed to short close GRN: ${serverMsg}`);
    }
  };

  const handleUpdateGRN = async () => {
    console.log("UPDATE BUTTON CLICKED");
    console.log("generatedGRN =", generatedGRN);

    const hasAnyStorageLocation = (modalData || []).some(row => !!row.storage_location);
    if (!hasAnyStorageLocation) {
      toast.error("Please select a Storage Location for at least one product before saving.");
      return;
    }

    if (!invoiceNo || !invoiceNo.trim()) {
      toast.error("Please enter an Invoice No before updating the GRN.");
      return;
    }
    try {
      const res = await axios.put(
        `${PURCHASE_API}/goods-receipt/update/${generatedGRN}`,
        {
          payment_terms: paymentTermNumber,

          mode_of_transport: modalData[0]?.mode_of_transport || "",
          delivery_type: modalData[0]?.delivery_type || "",
          freight_terms: modalData[0]?.freight_terms || "",
          insurance_terms: modalData[0]?.insurance_terms || "",
          transporter: modalData[0]?.transporter || "",
          purchase_type: modalData[0]?.purchase_type || "",
          state_grouping: modalData[0]?.state_grouping || "",
          po_header_lot_type: modalData[0]?.po_header_lot_type || "",

          // Kept for backward compatibility with the goods_receipt header
          // update (first row's values).
          storage_location: modalData[0]?.storage_location || "",
          storage_code: modalData[0]?.storage_code || "",
          invoice_no: invoiceNo || "",
          product_type: modalData[0]?.product_type || "",

          // NEW: full row list so the backend can sync the `stock` table
          // per batch, not just row 0. Each row identifies the batch via
          // product_code + batch_number.
          rows: (modalData || []).map(row => ({
            id: row.id,
            product_code: row.product_code || "",
            batch_number: row.batch_number || "",
            storage_location: row.storage_location || "",
            storage_code: row.storage_code || ""
          }))
        },
        { headers: authHeaders() }
      );

      console.log("UPDATE RESPONSE =", res.data);

      toast.success("GRN Updated Successfully");

      // Refresh displayed data
      viewGRN(generatedGRN);

    } catch (err) {
      console.error("UPDATE ERROR =", err.response?.data || err);
      toast.error("Failed to update GRN");
    }
  };
  const handleProductSelect = async (idx, productCode) => {
    const product = allProducts.find(p => p.productCode === productCode);
    if (!product) return;

    const updated = [...modalData];
    updated[idx] = {
      ...updated[idx],
      product_code: product.productCode,
      description: product.description || product.productDescription || "",
      uom: product.uom,
      product_cost: product.productCost,
      product_class: product.productClass || "",
      currency: product.currency || "",
      hsn_code: product.hsnCode,
      characteristics: [],
      batchCharacteristics: []
    };

    // ── Auto-fill header-level Product Type from the selected product ──
    const autoProductType = product.productType || product.product_type || "";
    if (autoProductType && !updated[0]?.product_type) {
      updated[0] = { ...updated[0], product_type: autoProductType };
    }

    setModalData(updated);

    try {
      // 🆕 Missing authHeaders() was causing this call to fail with 401
      // Unauthorized (every other axios call in this file passes it) —
      // the request was silently failing and falling into the catch
      // block below, which is why characteristics never populated.
      const pirRes = await axios.get(`${PURCHASE_API}/po/pir-info/${productCode}`, { headers: authHeaders() });
      const pir = pirRes.data;

      // 🆕 Apply this regardless of pir.found — the backend already falls
      // back to the product/purchase Class's blank characteristic template
      // (e.g. Over Tolerance) when no PIR exists, so gating on `found` was
      // silently throwing that fallback data away and leaving the row's
      // characteristics stuck at [] ("No characteristics available").
      if (pir) {
        const next = [...updated];
        next[idx] = {
          ...next[idx],
          product_code: product.productCode,
          description: product.description || product.productDescription || "",
          uom: product.uom,
          product_cost: pir.productCost ?? product.productCost,
          product_class: pir.productClass || product.productClass || "",
          currency: pir.currency || product.currency || "",
          hsn_code: product.hsnCode,
          characteristics: pir.characteristics || [],
          batchCharacteristics: [],
          _pirVendorName: pir.vendorName || ""
        };

        if (pir.found && pir.vendorName) {
          const otherVendors = next
            .filter((_, i) => i !== idx && _?.product_code)
            .map(r => r._pirVendorName)
            .filter(Boolean);

          const hasConflict = otherVendors.length > 0 && otherVendors.some(v => v !== pir.vendorName);

          if (hasConflict) {
            toast.warning(`Warning: "${productCode}" defaults to vendor "${pir.vendorName}" which differs from other products.`);
          } else if (!next[0]?.vendor_name) {
            next[0] = { ...next[0], vendor_name: pir.vendorName };
            if (pir.paymentTerms) setPaymentTermNumber(pir.paymentTerms);
          }
        }
        setModalData(next);
      }
    } catch (pirErr) {
      console.error("PIR fetch failed:", pirErr);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    if (typeof dateStr === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
    if (typeof dateStr === "string" && dateStr.includes("T")) return dateStr.split("T")[0];
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
    setGrnPdfBlob(null);
    setShowGrnViewModal(false);
    setFilterCategory("");
    setFilterSubCategory("");

    // Handle navigation back to the previous screen (when this GRN was opened
    // via a hyperlink from another screen, e.g. Vendor Return's "GRN No" column)
    const queryParams = new URLSearchParams(location.search);
    const returnTo = queryParams.get("returnTo");

    if (returnTo) {
      navigate(returnTo);
    } else if (queryParams.get("view")) {
      // If there's no returnTo, clean the URL parameters to match the actual route
      navigate("/cable/goods-receipt/goods-receipt", { replace: true });
    }
  };

  //eslint-disable-next-line
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const today = (() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  })();

  const allGRNs = grnList;

  // ── Order Type (header field, Manual GRN only) ──
  // Sits beside Product Type. "Service" lines have no Product Code (nothing
  // to pick from the product master) — Description becomes a free-text
  // field instead — and on POST they must land only in goods_receipt, never
  // in the stock table (see service.saveGRN, "BRANCH: MANUAL GRN").
  const orderTypeOptions = [
    { value: "Goods", label: "Goods" },
    { value: "Service", label: "Service" }
  ];
  const isServiceOrder =
    String(modalData?.[0]?.order_type || "").trim().toLowerCase() === "service";

  return (
    <Layout>
      <style>{`
        @media (max-width: 768px) {
          .gr-filter-card .row > div { flex: 0 0 100%; max-width: 100%; }
          .gr-page-title { font-size: 20px !important; }
        }
        .gr-table-wrapper { overflow-x: auto; -webkit-overflow-scrolling: touch; }
        .gr-status-badge {
          display: inline-block;
          padding: 2px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.3px;
        }
        .gr-status-approved  { background: #dcfce7; color: #166534; }
        .gr-status-pending   { background: #fef9c3; color: #854d0e; }
        .gr-status-rejected  { background: #fee2e2; color: #991b1b; }
        .gr-status-default   { background: #f1f5f9; color: #475569; }
        .gr-row-hover:hover  { background: #f8fafc; }
        .gr-tab-toggle {
          display: inline-flex;
          background: #f1f5f9;
          border-radius: 8px;
          padding: 3px;
          gap: 2px;
          margin-bottom: 14px;
        }
        .gr-tab-toggle button {
          border: none;
          background: transparent;
          border-radius: 6px;
          padding: 5px 20px;
          font-size: 13px;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        .gr-tab-toggle button.active-tab {
          background: #fff;
          color: #1e293b;
          box-shadow: 0 1px 3px rgba(0,0,0,0.12);
        }
      `}</style>

      {/* ===================== HEADER ===================== */}
<div style={styles.pageTitleBar}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", flexWrap: "wrap", gap: "12px" }}>
    <div>
      <h2 style={styles.pageTitle} className="gr-page-title">Goods Receipt</h2>
      <div style={styles.pageSubtitle}>View received goods and invoice details</div>
    </div>

    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <button className="btn btn-dark" style={{ paddingLeft: 16, paddingRight: 16 }} onClick={handleCreateManualGRN}>
        + Create Manual GRN
      </button>

      <button
        onClick={() => {
    setManualExists(null);
    setManualFile(null);
    setShowManual(true);
    fetch(USER_MANUAL_LIST_API, { headers: authHeaders() })
        .then((res) => res.json())
        .then((data) => {
            const norm = (v) => String(v || "").trim().toLowerCase();
            const match = (data?.data || []).find((m) =>
                norm(m.module_name) === norm(USER_MANUAL_SCOPE.moduleName) &&
                norm(m.process_name) === norm(USER_MANUAL_SCOPE.process) &&
                norm(m.sub_process_name) === norm(USER_MANUAL_SCOPE.subProcess)
            );
            if (match && match.drive_link) {
                setManualFile(match);
                setManualExists(true);
            } else {
                setManualExists(false);
            }
        })
        .catch(() => setManualExists(false));
}}
        title="View User Manual"
        style={{
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: "10px",
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          color: "#3b82f6",
          fontSize: "14px",
          fontWeight: "600",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#3b82f6"; }}
        onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; }}
      >
        <FileText size={18} />
        User Manual
      </button>
    </div>
  </div>
</div>

{/* --- User Manual Popup Modal --- */}
{showManual && (
  <div
    onClick={() => setShowManual(false)}
    style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      backgroundColor: "rgba(15, 23, 42, 0.6)", display: "flex",
      alignItems: "center", justifyContent: "center", zIndex: 1100,
    }}
  >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              width: "90vw",
              height: "97vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              boxShadow: "0 20px 25px -5px rgba(0,0,0,0.2)",
            }}
          >
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "14px 20px", borderBottom: "1px solid #e2e8f0",
      }}>
        <h4 style={{ margin: 0, color: "#0f172a", fontSize: "16px", fontWeight: "600" }}>
          User Manual
        </h4>
        <button
          onClick={() => setShowManual(false)}
          style={{
            border: "none", background: "#f1f5f9", borderRadius: "8px",
            width: "32px", height: "32px", cursor: "pointer", fontSize: "18px",
            color: "#475569", lineHeight: 1,
          }}
          title="Close"
        >
          ×
        </button>
      </div>

      {manualExists === null && (
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: "14px" }}>
          Checking for user manual...
        </div>
      )}

      {manualExists === false && (
        <div style={{
          flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", color: "#64748b", gap: "10px", padding: "20px", textAlign: "center"
        }}>
          <FileText size={40} color="#cbd5e1" />
          <div style={{ fontSize: "15px", fontWeight: 600, color: "#334155" }}>
            User Manual Not Available
          </div>
          <div style={{ fontSize: "13px", color: "#94a3b8", maxWidth: "320px" }}>
            The user manual for this module hasn't been uploaded yet. Please check back later or contact your administrator.
          </div>
        </div>
      )}

      {manualExists === true && manualFile && (() => {
    const MANUAL_SCALE = 1.25;
    return (
        <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
            <iframe
                src={manualFile.drive_link.replace("/view", "/preview")}
                title={manualFile.file_name || "User Manual"}
                allow="autoplay"
                style={{
                    border: "none",
                    width: `${100 / MANUAL_SCALE}%`,
                    height: `${100 / MANUAL_SCALE}%`,
                    transform: `scale(${MANUAL_SCALE})`,
                    transformOrigin: "top left",
                }}
            />
        </div>
    );
})()}
    </div>
  </div>
)}

      {/* ===================== FILTERS ===================== */}
      <div style={styles.filterCard} className="gr-filter-card">
        <div className="row g-3">
          <div className="col-md-4 col-sm-6">
            <label style={styles.filterLabel}>Purchase Organization</label>
            <Select
              styles={rsFilter}
              isClearable
              placeholder="Select"
              options={purchaseOrganizations.map((item) => ({
                value: item.grn_number || item.name || item,
                label: item.grn_number || item.name || item,
              }))}
              value={filters.purchaseOrganization ? { value: filters.purchaseOrganization, label: filters.purchaseOrganization } : null}
              onChange={(opt) => setFilters(prev => ({ ...prev, purchaseOrganization: opt?.value || "" }))}
            />
          </div>
          <div className="col-md-4 col-sm-6">
            <label style={styles.filterLabel}>Purchase Order ID</label>
            <Select
              styles={rsFilter}
              isClearable
              placeholder="Select"
              options={purchaseOrders.map((item) => ({
                value: item.grn_number || item,
                label: item.grn_number || item,
              }))}
              value={filters.purchaseOrderId ? { value: filters.purchaseOrderId, label: filters.purchaseOrderId } : null}
              onChange={(opt) => setFilters(prev => ({ ...prev, purchaseOrderId: opt?.value || "" }))}
            />
          </div>
          <div className="col-md-4 col-sm-6">
            <label style={styles.filterLabel}>Supplier</label>
            <Select
              styles={rsFilter}
              isClearable
              placeholder="Select"
              options={suppliers.map((item) => ({
                value: item.grn_number || item.name || item,
                label: item.grn_number || item.name || item,
              }))}
              value={filters.vendor ? { value: filters.vendor, label: filters.vendor } : null}
              onChange={(opt) => setFilters(prev => ({ ...prev, vendor: opt?.value || "" }))}
            />
          </div>


        </div>

      </div>

      {/* ===================== ACTIVE / POSTED TOGGLE ===================== */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "14px" }}>
        <div className="gr-tab-toggle">
          <button className={activeTab === "active" ? "active-tab" : ""} onClick={() => setActiveTab("active")}>
            Active
          </button>
          <button className={activeTab === "posted" ? "active-tab" : ""} onClick={() => setActiveTab("posted")}>
            Posted
          </button>
        </div>
      </div>

      {/* ===================== TABLE ===================== */}
      <div style={{ ...styles.tableContainer, overflowX: "auto" }} className="gr-table-wrapper">
        <table className="table mb-0" style={{ ...styles.erpTable, tableLayout: "auto", minWidth: 700 }}>
          <thead>
            <tr>
              {/* GRN No column: not applicable to the Active tab (those rows
                  are open POs without a finalized GRN yet) — only show it
                  on the Posted tab. */}
              {activeTab !== "active" && <th style={styles.erpTh}>GRN No</th>}
              <th style={styles.erpTh}>PO No</th>
              <th style={styles.erpTh}>Gate Pass No</th>
              <th style={styles.erpTh}>Vendor Name</th>
              <th style={styles.erpTh}>Purchase Organization</th>
              <th style={styles.erpTh}>Creation Date</th>
              <th style={styles.erpTh}>Status</th>
              <th style={{ ...styles.erpTh, width: 80 }}></th>
            </tr>
          </thead>
          <tbody>
            {allGRNs.length === 0 ? (
              <tr>
                <td colSpan={activeTab === "active" ? 7 : 8} style={{ ...styles.erpTd, textAlign: "center", color: "#94a3b8", padding: "32px 0" }}>
                  No records found
                </td>
              </tr>
            ) : (
              allGRNs.map((row, idx) => (
                <tr key={idx} className="gr-row-hover">
                  {activeTab !== "active" && (
                    <td style={{ ...styles.erpTd, fontWeight: 600, color: "#475569" }}>
                      {activeTab === "posted" && row.grn_number ? (
                        <button
                          style={{ background: "none", border: "none", color: "#1d4ed8", textDecoration: "underline", cursor: "pointer", padding: 0, fontSize: "13px", fontWeight: 600 }}
                          onClick={() => viewGRN(row.grn_number)}
                        >
                          {row.grn_number}
                        </button>
                      ) : "—"}
                    </td>
                  )}
                  <td style={{ ...styles.erpTd, fontWeight: 600 }}>
                    {row.purchase_order_id ? (
                      <button
                        style={{ background: "none", border: "none", color: "#1d4ed8", textDecoration: "underline", cursor: "pointer", padding: 0, fontSize: "13px", fontWeight: 600 }}
                        onClick={() => navigate("/cable/procurement/purchase-order", { state: { openPoNo: row.purchase_order_id } })}
                      >
                        {row.purchase_order_id}
                      </button>
                    ) : "-"}
                  </td>
                  <td style={styles.erpTd}>
                    {row.gate_pass_no
                      ? (
                        <button
                          style={{ background: "none", border: "none", color: "#166534", textDecoration: "underline", cursor: "pointer", padding: 0, fontSize: "13px", fontWeight: 600 }}
                          onClick={() => navigate(
                            `${GATE_PASS_ROUTE}?view=${encodeURIComponent(row.gate_pass_no)}&returnTo=${encodeURIComponent(location.pathname + location.search)}`
                          )}
                        >
                          {row.gate_pass_no}
                        </button>
                      )
                      : !row.purchase_order_id
                        ? "-"
                        : <span style={{ color: "#b91c1c", fontSize: 12 }} title="No Gate Pass linked to this PO — GRN cannot be posted until one is created">Gate Pass Not Done</span>
                    }
                  </td>
                  <td style={styles.erpTd}>{row.vendor_name || "-"}</td>
                  <td style={styles.erpTd}>{row.purchase_organization || "-"}</td>
                  <td style={styles.erpTd}>
                    {formatDateDMY(row.created_date)}
                  </td>
                  <td style={styles.erpTd}>{String(row.status || "—").toUpperCase()}</td>
                  <td style={styles.erpTd}>
                    <button
                      className="btn btn-outline-dark btn-sm"
                      style={{ fontSize: 12, whiteSpace: "nowrap" }}
                      onClick={() => {
                        // Posted tab: this IS a finalized GRN, always load it by grn_number.
                        // Active tab: even if a stray/old goods_receipt row exists for this PO
                        // (e.g. from a partial receipt), the PO is still open — always pull
                        // fresh live data from purchase_orders, not the stale GRN row.
                        if (activeTab === "posted" && row.grn_number) {
                          viewGRN(row.grn_number);
                        } else if (row.purchase_order_id) {
                          viewPO(row.purchase_order_id);
                        } else if (row.grn_number) {
                          viewGRN(row.grn_number);
                        }
                      }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ===================== MODAL ===================== */}
      {showModal && modalData && (
        <div style={styles.modalBackdrop} className="gr-modal-backdrop">
          <div style={{ ...styles.modal, maxWidth: "1200px", width: "90%", maxHeight: "90vh", fontSize: "14px" }}>

            {/* ================= HEADER ================= */}
            <div style={{ ...styles.modalHeader, padding: "10px 14px" }}>
              <div style={{ fontWeight: 600, fontSize: "18px" }}>
                {isManualGRN
                  ? "Create GRN"
                  : `GRN : ${modalData?.[0]?.grn_number || modalData?.[0]?.purchase_order_id || ""}`}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {(isManualGRN || activeTab !== "posted") && grnPermission.can_create && (
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={handleSaveGRN}
                    disabled={!isManualGRN && modalData?.[0]?.purchase_order_id && !modalData?.[0]?.gate_pass_no}
                    title={
                      (!isManualGRN && modalData?.[0]?.purchase_order_id && !modalData?.[0]?.gate_pass_no)
                        ? `No Gate Pass found for PO ${modalData?.[0]?.purchase_order_id}. Create one referencing this PO before posting.`
                        : ""
                    }
                  >
                    POST GRN
                  </button>
                )}
              </div>
            </div>

            {/* ================= BODY ================= */}
            <div style={{ ...styles.modalBody, padding: "14px" }} className="gr-modal-body">

              {/* ===== ROW 1: Product Type ===== */}
              <div className="row g-3 mb-3">
                <div className="col-md-4">
                  <label style={styles.compactLabel}>Product Type</label>
                  {isManualGRN ? (
                    <Select
                      styles={rsFilter}
                      isClearable
                      placeholder="Select"
                      options={productTypeOptions}
                      value={productTypeOptions.find(o => o.value === modalData?.[0]?.product_type) || null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].product_type = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  ) : (
                    <input
                      className="form-control"
                      style={{ ...styles.compactInput, backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                      value={modalData?.[0]?.product_type || ""}
                      readOnly
                    />
                  )}
                </div>

                {/* Order Type — Manual GRN only. "Service" hides the Product
                    Code picker on every row and makes Description free-text;
                    on POST those rows skip the stock table entirely. */}
                {isManualGRN && (
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Order Type</label>
                    <Select
                      styles={rsFilter}
                      isClearable
                      placeholder="Select"
                      options={orderTypeOptions}
                      value={orderTypeOptions.find(o => o.value === modalData?.[0]?.order_type) || null}
                      onChange={(opt) => {
                        const nextOrderType = opt?.value || "";
                        const goingService = String(nextOrderType).trim().toLowerCase() === "service";
                        const updated = modalData.map((row) => {
                          const next = { ...row, order_type: nextOrderType };
                          // Switching to Service: clear any product-master
                          // selection so a stale product_code never rides
                          // along with a free-typed service description.
                          if (goingService) {
                            next.product_code = "";
                          }
                          return next;
                        });
                        setModalData(updated);
                      }}
                    />
                  </div>
                )}
              </div>

              {/* ===== ROW 2: GRN Number / PO No. / Created By / Created Date / Purchase Organization / Purchase Planner / Location — ALL IN ONE LINE ===== */}
              <div className="row g-3 mb-3">
                {generatedGRN && (
                  <div className="col-md-2">
                    <label style={styles.compactLabel}>GRN Number</label>
                    <input
                      className="form-control"
                      style={styles.compactInput}
                      value={generatedGRN}
                      readOnly
                    />
                  </div>
                )}

                {!isManualGRN && (
                  <div className="col-md-2">
                    <label style={styles.compactLabel}>Purchase Order No.</label>
                    <input
                      className="form-control"
                      style={styles.compactInput}
                      value={modalData?.[0]?.purchase_order_id || ""}
                      readOnly
                    />
                  </div>
                )}

                {/* Created By — always the logged-in user's name, never editable */}
                <div className="col-md-2">
                  <label style={styles.compactLabel}>Created By</label>
                  <input
                    className="form-control"
                    style={{ ...styles.compactInput, backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                    value={modalData?.[0]?.created_by || currentUserName}
                    readOnly
                    disabled
                  />
                </div>

                {/* Created Date — always today's date, dd/mm/yyyy, never editable */}
                <div className="col-md-2">
                  <label style={styles.compactLabel}>Created Date</label>
                  <input
                    className="form-control"
                    style={{ ...styles.compactInput, backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                    value={formatDateDMY(modalData?.[0]?.created_date || getTodayLocal())}
                    readOnly
                    disabled
                  />
                </div>

                <div className="col-md-2">
                  <label style={styles.compactLabel}>Purchase Organization</label>
                  {isManualGRN ? (
                    <Select
                      styles={rsCompact}
                      menuShouldScrollIntoView={false}
                      isClearable
                      placeholder="Select Org"
                      options={manualPurchaseOrgs.map(p => ({
                        value: p.name,
                        label: p.name
                      }))}
                      value={
                        modalData?.[0]?.purchase_organization
                          ? {
                            value: modalData[0].purchase_organization,
                            label: modalData[0].purchase_organization
                          }
                          : null
                      }
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].purchase_organization = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  ) : (
                    <input
                      className="form-control"
                      style={{ ...styles.compactInput, backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                      value={modalData?.[0]?.purchase_organization || ""}
                      readOnly
                    />
                  )}
                </div>

                <div className="col-md-2">
                  <label style={styles.compactLabel}>Purchase Planner</label>
                  {isManualGRN ? (
                    <Select
                      styles={rsCompact}
                      menuShouldScrollIntoView={false}
                      isClearable
                      placeholder="Select Planner"
                      options={manualPurchasePlanners.map(p => ({
                        value: p.name,
                        label: p.name
                      }))}
                      value={
                        modalData?.[0]?.purchase_planner
                          ? {
                            value: modalData[0].purchase_planner,
                            label: modalData[0].purchase_planner
                          }
                          : null
                      }
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].purchase_planner = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  ) : (
                    <input
                      className="form-control"
                      style={{ ...styles.compactInput, backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                      value={modalData?.[0]?.purchase_planner || ""}
                      readOnly
                    />
                  )}
                </div>

                <div className="col-md-2">
                  <label style={styles.compactLabel}>Location</label>
                  {isManualGRN ? (
                    <Select
                      styles={rsCompact}
                      menuShouldScrollIntoView={false}
                      isClearable
                      placeholder="Select Location"
                      options={manualLocations.map(l => ({
                        value: l.name,
                        label: l.name
                      }))}
                      value={
                        modalData?.[0]?.location
                          ? {
                            value: modalData[0].location,
                            label: modalData[0].location
                          }
                          : null
                      }
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].location = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  ) : (
                    <input
                      className="form-control"
                      style={{ ...styles.compactInput, backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                      value={modalData?.[0]?.location || ""}
                      readOnly
                    />
                  )}
                </div>
              </div>

              {/* ===== ROW 4: Supplier / Invoice No ===== */}
              <div className="row g-3 mb-3">
                <div className="col-md-5">
                  <label style={styles.compactLabel}>Supplier</label>
                  <Select
                    styles={rsFilter}
                    isClearable
                    isDisabled={!isManualGRN}
                    placeholder="Select Vendor"
                    options={vendorList
                      .filter(v => v.partner_type?.toLowerCase() === "supplier")
                      .filter(v => v.status?.toLowerCase() !== "delete")
                      .map(v => ({
                        value: v.business_partner_name,
                        label: `${v.business_partner_name} - ${v.partner_code}`,
                        code: v.partner_code
                      }))
                    }
                    value={modalData[0]?.vendor_name ? { value: modalData[0].vendor_name, label: modalData[0].vendor_name } : null}
                    onChange={(opt) => {
                      const vendor = vendorList.find(v => v.business_partner_name === opt?.value);
                      const updated = [...modalData];
                      updated[0].vendor_name = opt?.value || "";
                      updated[0].vendor_code = vendor?.partner_code || "";
                      setModalData(updated);
                      handleVendorSelect(opt?.value || "");
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label style={styles.compactLabel}>Invoice No</label>
                  <input
                    className="form-control"
                    style={styles.compactInput}
                    placeholder="Enter Invoice No"
                    value={invoiceNo}
                    readOnly={!!generatedGRN}
                    onChange={(e) => setInvoiceNo(e.target.value)}
                  />
                </div>
              </div>

              {/* ================= TABS ================= */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "15px" }}>
                <div style={{ ...styles.tabs, margin: 0 }}>
                  {["basic", "product", "docs"].map(tab => (
                    <button
                      key={tab}
                      className={`btn ${createActiveTab === tab ? "btn-secondary" : "btn-light"}`}
                      style={styles.compactTabBtn}
                      onClick={() => setCreateActiveTab(tab)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  ))}
                </div>
              </div>

              {/* ================= BASIC TAB ================= */}
              {createActiveTab === "basic" && (
                <div className="row g-3">

                  {/* Payment Terms */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Payment Terms</label>
                    <input
                      className="form-control"
                      style={styles.compactInput}
                      placeholder="e.g. 30 Days"
                      value={paymentTermNumber || ""}
                      onChange={(e) => setPaymentTermNumber(e.target.value)}
                    />
                  </div>

                  {/* Mode Of Transport */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Mode Of Transport</label>
                    <Select
                      styles={rsFilter}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      isClearable
                      placeholder="Select"
                      options={modeOfTransports.map(item => ({ value: item.name, label: item.name }))}
                      value={modalData?.[0]?.mode_of_transport ? { value: modalData[0].mode_of_transport, label: modalData[0].mode_of_transport } : null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].mode_of_transport = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  </div>

                  {/* Delivery Type */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Delivery Type</label>
                    <Select
                      styles={rsFilter}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      isClearable
                      placeholder="Select"
                      options={deliveryTypes.map(item => ({ value: item.name, label: item.name }))}
                      value={modalData?.[0]?.delivery_type ? { value: modalData[0].delivery_type, label: modalData[0].delivery_type } : null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].delivery_type = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  </div>

                  {/* Freight Terms */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Freight Terms</label>
                    <Select
                      styles={rsFilter}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      isClearable
                      placeholder="Select"
                      options={freightTerms.map(item => ({ value: item.name, label: item.name }))}
                      value={modalData?.[0]?.freight_terms ? { value: modalData[0].freight_terms, label: modalData[0].freight_terms } : null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].freight_terms = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  </div>

                  {/* Insurance Terms */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Insurance Terms</label>
                    <Select
                      styles={rsFilter}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      isClearable
                      placeholder="Select"
                      options={insuranceTerms.map(item => ({ value: item.name, label: item.name }))}
                      value={modalData?.[0]?.insurance_terms ? { value: modalData[0].insurance_terms, label: modalData[0].insurance_terms } : null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].insurance_terms = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  </div>

                  {/* Transporter */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>Transporter</label>
                    <Select
                      styles={rsFilter}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      isClearable
                      placeholder="Select"
                      options={transporters.map(item => ({ value: item.name, label: item.name }))}
                      value={modalData?.[0]?.transporter ? { value: modalData[0].transporter, label: modalData[0].transporter } : null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].transporter = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  </div>



                  {/* PO Header Lot Type */}
                  <div className="col-md-4">
                    <label style={styles.compactLabel}>PO Header Lot Type</label>
                    <Select
                      styles={rsFilter}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      isClearable
                      placeholder="Select"
                      options={poHeaderLotTypes.map(item => ({ value: item.name, label: item.name }))}
                      value={modalData?.[0]?.po_header_lot_type ? { value: modalData[0].po_header_lot_type, label: modalData[0].po_header_lot_type } : null}
                      onChange={(opt) => {
                        const updated = [...modalData];
                        updated[0].po_header_lot_type = opt?.value || "";
                        setModalData(updated);
                      }}
                    />
                  </div>

                </div>
              )}

              {/* ================= PRODUCT TAB ================= */}
              {createActiveTab === "product" && (
                <>
                  {isManualGRN && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                      <button
                        className="btn btn-dark btn-sm"
                        style={{ whiteSpace: 'nowrap' }}
                        onClick={() =>
                          setModalData([
                            ...modalData,
                            {
                              purchase_order_id: "",
                              purchase_organization: "",
                              purchase_planner: "",
                              location: "",
                              vendor_name: "",
                              product_code: "",
                              description: "",
                              uom: "",
                              currency: "",
                              product_class: "",
                              requirement_qty: "",
                              open_po_qty: "",
                              requirement_date: "",
                              product_cost: ""
                            }
                          ])
                        }
                      >
                        + Add Product
                      </button>
                    </div>
                  )}

                  {isManualGRN && !isServiceOrder && String(modalData?.[0]?.product_type).trim().toLowerCase() !== 'asset' && (
                    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', marginBottom: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: '#64748b', whiteSpace: 'nowrap' }}>Filter:</span>
                        <div style={{ minWidth: 160, flex: '1 1 150px', maxWidth: 220 }}>
                          <Select
                            isClearable
                            placeholder="All Categories"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            options={categoryOptions.map(c => ({ value: c.name || c, label: c.name || c }))}
                            value={filterCategory ? { value: filterCategory, label: filterCategory } : null}
                            onChange={(opt) => { setFilterCategory(opt?.value || ""); setFilterSubCategory(""); }}
                            styles={{
                              control: (base) => ({ ...base, minHeight: 30, fontSize: '12px' }),
                              valueContainer: (base) => ({ ...base, padding: '2px 6px' }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              indicatorsContainer: (base) => ({ ...base, alignSelf: 'flex-start', paddingTop: 2 }),
                              dropdownIndicator: (base) => ({ ...base, padding: 2 }),
                              clearIndicator: (base) => ({ ...base, padding: 2 }),
                              placeholder: (base) => ({ ...base, fontSize: '12px', color: '#94a3b8' }),
                              menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                              menu: (base) => ({ ...base, fontSize: '12px' }),
                            }}
                          />
                        </div>
                        <div style={{ minWidth: 160, flex: '1 1 150px', maxWidth: 220 }}>
                          <Select
                            isClearable
                            placeholder="All Sub-Categories"
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            options={subCategoryOptions
                              .filter(sc => {
                                const scName = sc.name || sc;
                                if (!filterCategory) return true;
                                return allProducts.some(p => p.productCategory === filterCategory && p.subCategory === scName);
                              })
                              .map(sc => ({ value: sc.name || sc, label: sc.name || sc }))}
                            value={filterSubCategory ? { value: filterSubCategory, label: filterSubCategory } : null}
                            onChange={(opt) => setFilterSubCategory(opt?.value || "")}
                            styles={{
                              control: (base) => ({ ...base, minHeight: 30, fontSize: '12px' }),
                              valueContainer: (base) => ({ ...base, padding: '2px 6px' }),
                              input: (base) => ({ ...base, margin: 0, padding: 0 }),
                              indicatorsContainer: (base) => ({ ...base, alignSelf: 'flex-start', paddingTop: 2 }),
                              dropdownIndicator: (base) => ({ ...base, padding: 2 }),
                              clearIndicator: (base) => ({ ...base, padding: 2 }),
                              placeholder: (base) => ({ ...base, fontSize: '12px', color: '#94a3b8' }),
                              menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                              menu: (base) => ({ ...base, fontSize: '12px' }),
                            }}
                          />
                        </div>
                        {(filterCategory || filterSubCategory) && (
                          <button
                            className="btn btn-sm btn-outline-secondary"
                            style={{ fontSize: 11, whiteSpace: 'nowrap', height: 30, padding: '0 10px' }}
                            onClick={() => { setFilterCategory(""); setFilterSubCategory(""); }}
                          >
                            ✕ Clear
                          </button>
                        )}
                        <span style={{ fontSize: '12px', color: '#94a3b8', marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                          {(() => {
                            const headerType = modalData?.[0]?.product_type;
                            const isNonPurchasableType = ['finished goods', 'semi finished'].includes(
                              String(headerType || '').trim().toLowerCase()
                            );
                            const filtered = isNonPurchasableType ? [] : allProducts.filter(p => {
                              if (
                                headerType &&
                                String(p.productType || "").trim().toLowerCase() !==
                                String(headerType).trim().toLowerCase()
                              ) return false;
                              if (filterCategory && p.productCategory !== filterCategory) return false;
                              if (filterSubCategory && p.subCategory !== filterSubCategory) return false;
                              return true;
                            });
                            return `${filtered.length} product${filtered.length !== 1 ? "s" : ""} available`;
                          })()}
                        </span>
                      </div>
                    </div>
                  )}

                  <div style={{ ...styles.tableContainer, overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                    <table className="table" style={{ ...styles.erpTable, tableLayout: "auto", minWidth: "1990px" }}>
                      <thead>
                        <tr>
                          <th style={{ ...styles.erpTh, width: "40px", textAlign: "center" }}>Item</th>
                          <th style={{ ...styles.erpTh, minWidth: "200px" }}>
                            {isServiceOrder
                              ? "Product Code"
                              : String(modalData?.[0]?.product_type).trim().toLowerCase() === "asset" ? "Asset Code" : "Product Code"}
                          </th>
                          <th style={{ ...styles.erpTh, minWidth: "200px" }}>
                            {isServiceOrder
                              ? "Description"
                              : String(modalData?.[0]?.product_type).trim().toLowerCase() === "asset" ? "Asset Description" : "Description"}
                          </th>
                          <th style={{ ...styles.erpTh, width: "70px", textAlign: "center" }}>Currency</th>
                          <th style={{ ...styles.erpTh, width: "110px", textAlign: "right" }}>Product Cost</th>
                          <th style={{ ...styles.erpTh, width: "120px" }}>Batch No</th>
                          <th style={{ ...styles.erpTh, width: "180px" }}>
                            Supplier Batch
                          </th>
                          <th style={{ ...styles.erpTh, width: "60px", textAlign: "center" }}>Supplier Data</th>
                          <th style={{ ...styles.erpTh, width: "350px" }}>
                            Storage Location
                          </th>
                          <th style={{ ...styles.erpTh, width: "60px", textAlign: "center" }}>UOM</th>
                          <th style={{ ...styles.erpTh, width: "110px", textAlign: "right" }}>Qty</th>
                          <th style={{ ...styles.erpTh, width: "110px", textAlign: "center" }}>Over Tolerance (%)</th>
                          <th style={{ ...styles.erpTh, textAlign: "center", width: "130px" }}>Range</th>
                          {!isManualGRN && (
                            <th style={{ ...styles.erpTh, width: "110px", textAlign: "right" }}>Open PO</th>
                          )}
                          <th style={{ ...styles.erpTh, width: "150px", textAlign: "right" }}>Received Qty</th>
                          <th style={{ ...styles.erpTh, width: "110px", textAlign: "center" }}>Delivery Date</th>
                          <th style={{ ...styles.erpTh, width: "130px", textAlign: "center" }}>Received Date</th>

                        </tr>
                      </thead>
                      <tbody>
                        {modalData.map((row, idx) => (
                          <tr key={idx}>
                            <td style={{ ...styles.erpTd, textAlign: "center" }}>{idx + 1}</td>

                            {/* Product Code — Service order lines have nothing
                                to pick from the product master, so the
                                dropdown doesn't render at all for them. */}
                            <td style={styles.erpTd}>
                              {isServiceOrder ? (
                                <input
                                  className="form-control form-control-sm p-1"
                                  style={{ fontSize: "12px", backgroundColor: "#f8fafc", cursor: "not-allowed" }}
                                  value="Not applicable"
                                  readOnly
                                  disabled
                                />
                              ) : (
                              <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                placeholder={String(modalData?.[0]?.product_type).trim().toLowerCase() === "asset" ? "Select Asset" : "Select Product"}
                                isDisabled={!isManualGRN}
                                isClearable={isManualGRN}
                                value={row.product_code
                                  ? {
                                    value: row.product_code,
                                    label: (() => {
                                      const p = allProducts.find(p => p.productCode === row.product_code);
                                      return p ? `${p.productCode} - ${p.description || p.productDescription || ""}` : row.product_code;
                                    })()
                                  }
                                  : null}
                                options={
                                  // Finished Goods / Semi Finished stay valid choices in the
                                  // Product Type dropdown, but they're manufacturing outputs,
                                  // not receivable purchase items — so the Product Code
                                  // dropdown must stay empty ("No options") for these two
                                  // types no matter what's in the product master.
                                  ['finished goods', 'semi finished'].includes(
                                    String(modalData?.[0]?.product_type || '').trim().toLowerCase()
                                  )
                                    ? []
                                    : allProducts
                                        .filter(p => {
                                          const headerType = modalData?.[0]?.product_type;
                                          if (
                                            headerType &&
                                            String(p.productType || "").trim().toLowerCase() !==
                                            String(headerType).trim().toLowerCase()
                                          ) return false;
                                          if (filterCategory && p.productCategory !== filterCategory) return false;
                                          if (filterSubCategory && p.subCategory !== filterSubCategory) return false;
                                          return true;
                                        })
                                        .map(p => ({
                                          value: p.productCode,
                                          label: `${p.productCode} - ${p.description || p.productDescription || ""}`,
                                        }))
                                }
                                onChange={async (opt) => {
                                  const code = opt?.value || "";
                                  if (code) {
                                    await handleProductSelect(idx, code);
                                  } else {
                                    const updated = [...modalData];
                                    updated[idx] = {
                                      ...updated[idx],
                                      product_code: "",
                                      description: "",
                                      uom: "",
                                      currency: "",
                                      product_class: "",
                                      product_cost: "",
                                      hsn_code: "",
                                      characteristics: []
                                    };
                                    setModalData(updated);
                                  }
                                }}
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: '13px', borderColor: '#ced4da', boxShadow: 'none' }),
                                  valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                  input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                  indicatorsContainer: (base) => ({ ...base, height: 32 }),
                                  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                  menu: (base) => ({ ...base, fontSize: '13px' }),
                                  container: (base) => ({ ...base, minWidth: '180px' }),
                                }}
                              />
                              )}
                            </td>

                            {/* Description — free-typed for Service order
                                lines (nothing to auto-fill from a product
                                pick); read-only display otherwise, same as before. */}
                            <td style={{ ...styles.erpTd, whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
                              {isServiceOrder ? (
                                <input
                                  className="form-control form-control-sm p-1"
                                  style={{ fontSize: "12px", minWidth: "180px" }}
                                  value={row.description || ""}
                                  placeholder="Enter description"
                                  onChange={(e) => {
                                    const updated = [...modalData];
                                    updated[idx] = { ...updated[idx], description: e.target.value };
                                    setModalData(updated);
                                  }}
                                />
                              ) : (
                                row.description
                              )}
                            </td>

                            {/* Currency */}
                            <td style={{ ...styles.erpTd, textAlign: "center" }}>
                              <input
                                className="form-control form-control-sm p-1 text-center"
                                style={{ fontSize: "12px", width: "60px" }}
                                value={row.currency || ""}
                                onChange={(e) => {
                                  const updated = [...modalData];
                                  updated[idx] = { ...updated[idx], currency: e.target.value.toUpperCase() };
                                  setModalData(updated);
                                }}
                                maxLength={5}
                                placeholder="INR"
                              />
                            </td>

                            {/* Product Cost */}
                            <td style={styles.erpTd}>
                              <input
                                className="form-control form-control-sm p-1 text-end"
                                style={{ fontSize: "12px" }}
                                value={row.product_cost ?? ""}
                                onChange={(e) => {
                                  const updated = [...modalData];
                                  updated[idx].product_cost = e.target.value;
                                  setModalData(updated);
                                }}
                              />
                            </td>

                            {/* BATCH NO */}

                            <td style={styles.erpTd}>
                              <input
                                className="form-control form-control-sm p-1"
                                style={{ fontSize: "12px" }}
                                value={batchData[idx] ?? row.batch_number ?? ""}  // ← ADD row.batch_number fallback
                                onChange={(e) => handleBatchChange(idx, e.target.value)}
                                placeholder="Batch No"
                              />
                            </td>
                            <td style={styles.erpTd}>
                              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <div
                                  style={{
                                    flex: 1,
                                    fontSize: "12px",
                                    color: "#475569",
                                    background: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "6px",
                                    padding: "4px 8px",
                                    minHeight: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    flexWrap: "wrap",
                                    cursor: "default",
                                    minWidth: "120px",
                                  }}
                                >
                                  {row.supplier_batches?.filter((sb) => sb && (typeof sb === "string" ? sb : sb.batch_number)).length > 0 ? (
                                    row.supplier_batches
                                      .filter((sb) => sb && (typeof sb === "string" ? sb : sb.batch_number))
                                      .map((sb, i) => (
                                        <span
                                          key={i}
                                          style={{
                                            background: "#1e293b",
                                            color: "#fff",
                                            borderRadius: "4px",
                                            padding: "1px 7px",
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {typeof sb === "string"
                                            ? sb
                                            : `${sb.batch_number}${sb.qty ? ` (${sb.qty}${sb.uom ? " " + sb.uom : ""})` : ""}`}
                                        </span>
                                      ))
                                  ) : (
                                    <span style={{ color: "#cbd5e1", fontSize: "11px" }}>No batches</span>
                                  )}
                                </div>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setCurrentRowIndex(idx);
                                    setSupplierBatches(
                                      row.supplier_batches?.length
                                        ? row.supplier_batches.map((sb) =>
                                          typeof sb === "string"
                                            ? { batch_number: sb, qty: "", uom: row.uom || "" }
                                            : { ...sb, uom: sb.uom || row.uom || "" }
                                        )
                                        : [{ batch_number: "", qty: "", uom: row.uom || "" }]
                                    );
                                    setShowSupplierBatchModal(true);
                                  }}
                                  style={{
                                    background: "#1e293b",
                                    border: "none",
                                    borderRadius: "6px",
                                    color: "#fff",
                                    width: "28px",
                                    height: "28px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    fontSize: "16px",
                                    flexShrink: 0,
                                  }}
                                  title="Manage Supplier Batches"
                                >
                                  +
                                </button>
                              </div>
                            </td>

                            {/* Supplier Data — icon only, after Batch No. Opens the
                                Characteristics modal filtered to Supplier Description only. */}
                            <td style={{ ...styles.erpTd, textAlign: "center" }}>
                              {(row.product_class || allProducts.find(p => p.productCode === row.product_code)?.productClass) && (
                                <span
                                  style={{ cursor: "pointer", color: "#1d4ed8", fontWeight: "bold", fontSize: "14px" }}
                                  title="View / Edit Supplier Description"
                                  onClick={() => handleOpenCharModal(idx, row, "supplier")}
                                >
                                  ▶
                                </span>
                              )}
                            </td>

                            {/* STORAGE BIN */}
                            <td
                              style={{
                                ...styles.erpTd,
                                minWidth: "350px",
                                width: "350px"
                              }}
                            >
                              <Select
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                  ...rsFilter,
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                  }),
                                  control: (base, state) => {
                                    const merged = rsFilter.control(base, state);
                                    return {
                                      ...merged,
                                      borderColor: !row.storage_location ? "#dc3545" : merged.borderColor
                                    };
                                  }
                                }}
                                isClearable
                                placeholder="Select Storage Location *"
                                options={storageLocations.map(item => ({
                                  value: `${item.storage_location}|${item.storage_code}`,
                                  label: `${item.storage_location} - ${item.storage_code}`
                                }))}
                                value={
                                  row.storage_location
                                    ? {
                                      value: `${row.storage_location}|${row.storage_code}`,
                                      label: `${row.storage_location} - ${row.storage_code}`
                                    }
                                    : null
                                }
                                onChange={(opt) => {
                                  const updated = [...modalData];

                                  if (!opt) {
                                    updated[idx] = {
                                      ...updated[idx],
                                      storage_location: "",
                                      storage_code: ""
                                    };
                                  } else {
                                    const selected = storageLocations.find(
                                      item =>
                                        `${item.storage_location}|${item.storage_code}` ===
                                        opt.value
                                    );

                                    updated[idx] = {
                                      ...updated[idx],
                                      storage_location: selected?.storage_location || "",
                                      storage_code: selected?.storage_code || ""
                                    };
                                  }

                                  setModalData(updated);
                                }}
                              />
                            </td>    <td style={{ ...styles.erpTd, textAlign: "center" }}>{row.uom}</td>

                            {/* Qty — for manual GRN this is read-only and mirrors Received Qty */}
                            <td style={styles.erpTd}>
                              <input
                                type="number"
                                className="form-control form-control-sm p-1 text-end"
                                style={{ fontSize: "12px", minWidth: "100px" }}
                                value={
                                  isManualGRN
                                    ? (receivedData[idx]?.received_qty ?? "")
                                    : (row.requirement_qty ?? "")
                                }
                                readOnly={isManualGRN}
                                onChange={(e) => {
                                  if (isManualGRN) return;
                                  const updated = [...modalData];
                                  updated[idx].requirement_qty = e.target.value;
                                  setModalData(updated);
                                }}
                              />
                            </td>

                            {/* Over Tolerance (%) — typed directly on the line (replaces the old
                                Purchase Class column + ▶ popup). Saved as the "Over Tolerance"
                                characteristic; the Range next to it updates as soon as a number
                                is entered. Locked once the GRN is posted. */}
                            <td style={styles.erpTd}>
                              <input
                                className="form-control form-control-sm p-1 text-end"
                                style={{ fontSize: "12px", minWidth: "70px" }}
                                inputMode="decimal"
                                placeholder="0"
                                value={getOverTolerance(row)}
                                onChange={(e) => handleOverToleranceChange(idx, e.target.value)}
                                readOnly={!!row.grn_number}
                              />
                            </td>

                            {/* Range — derived from Qty + Over Tolerance % (entered in the column to the left).
                                Display + storage only — no longer enforced against Received Qty. */}
                            <td style={{ ...styles.erpTd, textAlign: "center", fontSize: "12px", whiteSpace: "nowrap" }}>
                              {getToleranceRange(row, idx).rangeText ? (
                                <span style={{ color: "#16a34a", fontWeight: 600 }}>
                                  {getToleranceRange(row, idx).rangeText}
                                </span>
                              ) : (
                                "—"
                              )}
                            </td>

                            {/* Open PO — not applicable to manual GRN, hidden */}
                            {!isManualGRN && (
                              <td style={styles.erpTd}>
                                <input
                                  type="number"
                                  className="form-control form-control-sm p-1 text-end"
                                  style={{ fontSize: "12px", minWidth: "100px" }}
                                  value={getEffectiveOpenPo(row).toFixed(2)}
                                  readOnly
                                />
                              </td>
                            )}
                            {/* RECEIVED QTY — for manual GRN, typing here also drives the Qty column above */}
                            <td style={styles.erpTd}>
                              <input
                                type="number"
                                min="1"
                                // Manual GRN: no max — Received Qty is allowed to exceed the
                                // Range/tolerance shown for the line (there's no PO ceiling to
                                // respect). Automatic GRN uses the tolerance Range as the
                                // browser-level hint (falls back to Open PO qty when no Over
                                // Tolerance is set), so e.g. Qty 100 / Range ≤106 lets the user
                                // type up to 106.
                                max={isManualGRN ? undefined : getReceivedQtyCeiling(row)}
                                step="1"
                                className="form-control form-control-sm p-1 text-end"
                                style={{ fontSize: "12px", minWidth: "100px" }}
                                value={receivedData[idx]?.received_qty ?? ""}
                                onChange={(e) => handleReceivedChange(idx, "received_qty", e.target.value)}
                                placeholder="Qty"
                                readOnly={!!row.grn_number}
                              />
                            </td>

                            {/* REQUIREMENT DATE */}
                            <td style={{ ...styles.erpTd, textAlign: "center" }}>
                              {isManualGRN ? (
                                <input
                                  type="date"
                                  className="form-control form-control-sm p-1"
                                  style={{ fontSize: "12px", minWidth: "110px" }}
                                  value={row.delivery_date || ""}
                                  onChange={(e) => {
                                    const updated = [...modalData];
                                    updated[idx].delivery_date = e.target.value;
                                    setModalData(updated);
                                  }}
                                />
                              ) : (
                                <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                                  {row.delivery_date
                                    ? formatDateDMY(String(row.delivery_date).split("T")[0])
                                    : "—"}
                                </span>
                              )}
                            </td>

                            {/* RECEIVED DATE */}
                            <td style={{ ...styles.erpTd, textAlign: "center" }}>
                              <input
                                type="date"
                                className="form-control form-control-sm p-1"
                                style={{ fontSize: "12px", minWidth: "120px" }}
                                value={receivedData[idx]?.received_date || today}
                                onChange={(e) => handleReceivedChange(idx, "received_date", e.target.value)}
                              />
                            </td>



                            {/* Actions */}
                            <td style={{ ...styles.erpTd, textAlign: "center" }}>
                              <div style={{ display: "flex", gap: "4px", justifyContent: "center", alignItems: "center" }}>
                                {isManualGRN && (
                                  <>
                                    <button
                                      className="btn btn-sm py-0"
                                      style={{ color: "#16a34a", border: "none", background: "transparent", lineHeight: 1, padding: "2px 6px" }}
                                      title="Insert product below"
                                      onClick={() => insertGRRowAfter(idx)}
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    </button>
                                    <button
                                      className="btn btn-sm py-0"
                                      style={{ color: "#ef4444", border: "none", background: "transparent", lineHeight: 1, padding: "2px 6px" }}
                                      title="Delete Product"
                                      onClick={() => deleteGRRow(idx)}
                                    >
                                      <FaTrash />
                                    </button>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {/* ================= DOCS TAB ================= */}
              {createActiveTab === "docs" && (
                <div style={{ background: "#fff", borderRadius: 8, padding: 16, border: "1px solid #e2e8f0", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>

                  {/* Auto-generated GRN form — View / Download / Print, same as Purchase Requisition's Docs tab */}
                  {grnPdfBlob ? (
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ border: "1px solid #dee2e6", borderRadius: "6px", padding: "16px", background: "#fff" }}>
                        <div style={{ marginBottom: "12px" }}>
                          <span style={{ fontSize: "18px", marginRight: "8px" }}>📄</span>
                          <span style={{ fontSize: "14px", fontWeight: 500, color: "#0f172a" }}>
                            {grnPdfBlob.filename}
                          </span>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button className="btn btn-dark btn-sm" onClick={() => setShowGrnViewModal(true)}>
                            View
                          </button>
                          <button className="btn btn-dark btn-sm" onClick={() => handleDownloadGRN(grnPdfBlob.grnNo)}>
                            Download
                          </button>
                          <button
                            className="btn btn-outline-dark btn-sm"
                            onClick={() => {
                              const grnNum = grnPdfBlob.grnNo || generatedGRN;
                              window.open(`/goods-receipt-view/${grnNum}?action=print`, "_blank");
                            }}
                          >
                            Print
                          </button>
                        </div>
                      </div>

                      {showGrnViewModal && (
                        <div
                          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
                          onClick={(e) => { if (e.target === e.currentTarget) setShowGrnViewModal(false); }}
                        >
                          <div style={{ width: "90%", height: "90%", background: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", borderBottom: "1px solid #e2e8f0" }}>
                              <span style={{ fontWeight: 600, fontSize: "14px" }}>{grnPdfBlob.filename}</span>
                              <button onClick={() => setShowGrnViewModal(false)} style={{ background: "none", border: "none", fontSize: "18px", cursor: "pointer", color: "#64748b" }}>
                                ✕
                              </button>
                            </div>
                            <iframe
                              src={`/goods-receipt-view/${grnPdfBlob.grnNo || generatedGRN}`}
                              title="Goods Receipt"
                              width="100%"
                              style={{ flex: 1, border: "none" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ border: "1px dashed #cbd5e1", borderRadius: "6px", padding: "16px", textAlign: "center", color: "#64748b" }}>
                        {generatedGRN
                          ? "No PDF available"
                          : "Post the GRN to get a GRN number before the form can be viewed, downloaded, or printed."}
                      </div>
                    </div>
                  )}

                  {/* Upload drop zone — same look as Purchase Requisition's Docs tab */}
                  <div style={{ marginBottom: 16 }}>
                    <label
                      htmlFor="grnDocFileInput"
                      style={{
                        display: "flex", flexDirection: "column", alignItems: "center",
                        justifyContent: "center", border: "2px dashed #cbd5e1", borderRadius: 8,
                        padding: "18px 12px", cursor: "pointer",
                        background: "#f8fafc"
                      }}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <span style={{ fontSize: 22 }}>📁</span>
                      <span style={{ fontSize: 13, color: "#475569", fontWeight: 500, marginTop: 4 }}>
                        {docsUploading ? "Uploading…" : "Click to attach documents"}
                      </span>
                      <span style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                        PDF, DOCX, XLSX (max {maxGrnDocSizeKb} KB per file)
                      </span>
                      <input
                        id="grnDocFileInput"
                        type="file"
                        multiple
                        style={{ display: "none" }}
                        onChange={handleGrnDocUpload}
                      />
                    </label>
                  </div>

                  {/* Files list — server (Google Drive-backed) list once the GRN
                      has a number, otherwise the locally staged pre-save files. */}
                  {generatedGRN ? (
                    uploadedDocs.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "28px 0", color: "#94a3b8", fontSize: 13 }}>
                        No documents attached yet.
                      </div>
                    ) : (
                      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                        <thead>
                          <tr>
                            <th style={styles.erpTh}>#</th>
                            <th style={styles.erpTh}>File Name</th>
                            <th style={styles.erpTh}>Size</th>
                            <th style={styles.erpTh}>Uploaded At</th>
                            <th style={styles.erpTh}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {uploadedDocs.map((doc, idx) => (
                            <tr key={idx} style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
                              <td style={styles.erpTd}>{idx + 1}</td>
                              <td style={styles.erpTd}>
                                <span style={{ color: "#1e293b", fontWeight: 500 }}>{doc.originalname || doc.filename}</span>
                              </td>
                              <td style={styles.erpTd}>
                                {doc.size
                                  ? doc.size > 1024 * 1024
                                    ? `${(doc.size / (1024 * 1024)).toFixed(2)} MB`
                                    : `${(doc.size / 1024).toFixed(1)} KB`
                                  : '—'}
                              </td>
                              <td style={styles.erpTd}>{doc.uploadedAt ? new Date(doc.uploadedAt).toLocaleString() : '—'}</td>
                              <td style={styles.erpTd}>
                                <button
                                  type="button"
                                  onClick={() => handleDocDownload(doc)}
                                  style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 4,
                                    color: '#2563eb', fontWeight: 600, fontSize: 12,
                                    textDecoration: 'none', padding: '3px 10px',
                                    border: '1px solid #bfdbfe', borderRadius: 5,
                                    background: '#eff6ff', cursor: 'pointer'
                                  }}
                                >
                                  ⬇ Download
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )
                  ) : (
                    uploadedGrnDocs.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "28px 0", color: "#94a3b8", fontSize: 13 }}>
                        No documents attached yet — files chosen here upload once you Save or Post the GRN.
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        {uploadedGrnDocs.map((file, i) => (
                          <div
                            key={`${file.name}-${i}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              border: "1px solid #e2e8f0",
                              borderRadius: 6,
                              padding: "6px 10px",
                              fontSize: 13,
                            }}
                          >
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              📎 {file.name} ({(file.size / 1024).toFixed(1)} KB)
                            </span>
                            <button
                              type="button"
                              onClick={() => handleRemoveGrnDoc(i)}
                              style={{ background: "transparent", border: "none", color: "#ef4444", cursor: "pointer", marginLeft: 8 }}
                              title="Remove"
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    )
                  )}
                </div>
              )}

              <CharacteristicsModal
                modalVisible={modalVisible}
                selectedCharacteristics={selectedCharacteristics}
                isEditing={true}
                handleChange={(idx, val) => {
                  const u = [...selectedCharacteristics];
                  u[idx].value = val;
                  setSelectedCharacteristics(u);
                }}
                handleAddCharacteristic={(newChar) => {
                  const u = [...selectedCharacteristics, newChar];
                  setSelectedCharacteristics(u);
                }}
                handleClose={() => handleSaveCharModal(selectedCharacteristics)}
              />

            </div>

            {/* ================= FOOTER ================= */}
            <div style={styles.modalFooter}>
              {/* Save removed for manual GRN creation — POST GRN (top) is the only save/create action.
      Also removed when viewing a PO from the Active tab that hasn't been converted into a
      GRN yet (generatedGRN is empty in that case) — POST GRN is the only valid action there. */}
              {!isManualGRN && generatedGRN && grnPermission.can_edit && (
                <button
                  className="btn btn-dark btn-sm"
                  onClick={handleUpdateGRN}
                >
                  Save
                </button>
              )}

              {(isManualGRN || activeTab !== "posted") && grnPermission.can_create && (
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={handleShortCloseGRN}
                  title="Post this GRN with whatever's been received and permanently close the remaining open quantity — no further receipt expected."
                >
                  Short Close
                </button>
              )}

              <button
                className="btn btn-secondary btn-sm"
                onClick={closeModal}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ===================== PRODUCT DETAILS MODAL ===================== */}
      {showProductModal && productDetails && (
        <div style={styles.modalBackdrop}>
          <div style={{ ...styles.modal, maxWidth: "950px", width: "95%", maxHeight: "85vh", padding: "14px", fontSize: "13px" }}>
            <div style={{ padding: "12px" }}>
              <table className="table table-bordered table-sm mb-3">
                <thead style={{ background: "#f8fafc", fontWeight: 600 }}>
                  <tr>
                    <th>{String(productDetails.product_type || modalData?.[0]?.product_type).trim().toLowerCase() === "asset" ? "Asset Code" : "Product Code"}</th>
                    <th>HSN Code</th>
                    <th>Quantity</th>
                    <th>Unit Cost</th>
                    <th>Total Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{productDetails.product_code}</td>
                    <td>{productDetails.hsnCode}</td>
                    <td>{productDetails.requirement_qty}</td>
                    <td>₹ {productDetails.product_cost}</td>
                    <td>{productDetails.discount}</td>
                    <td style={{ fontWeight: 600 }}>₹ {productDetails.totalCost}</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 10px", borderTop: "1px solid #999", borderBottom: "1px solid #999", marginBottom: "10px", fontWeight: 600 }}>
                <span>Net Price :</span>
                <span>₹ {productDetails.netPriceAfterDiscount}</span>
              </div>

              <table className="table table-sm" style={{ width: "50%", marginLeft: "auto" }}>
                <tbody>
                  <tr>
                    <td>CGST @ {productDetails.cgst}%</td>
                    <td style={{ textAlign: "right" }}>₹ {productDetails.cgstAmount}</td>
                  </tr>
                  <tr>
                    <td>SGST @ {productDetails.sgst}%</td>
                    <td style={{ textAlign: "right" }}>₹ {productDetails.sgstAmount}</td>
                  </tr>
                  <tr style={{ borderTop: "1px solid #000", fontWeight: 600 }}>
                    <td>Total GST</td>
                    <td style={{ textAlign: "right" }}>₹ {productDetails.totalGST - productDetails.igstAmount}</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ display: "flex", justifyContent: "space-between", padding: "12px", marginTop: "8px", background: "#f1f5f9", fontWeight: 700, fontSize: "15px", borderRadius: "4px" }}>
                <span>Grand Total :</span>
                <span>₹ {productDetails.finalPriceAfterGST - productDetails.igstAmount}</span>
              </div>
            </div>

            <div style={{ ...styles.modalFooter, padding: "10px 14px" }}>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowProductModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />


      {showSupplierBatchModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowSupplierBatchModal(false); }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "620px",
              maxWidth: "95vw",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div
              style={{
                background: "#1e293b",
                padding: "14px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                <span style={{ color: "#fff", fontWeight: 700, fontSize: "15px" }}>
                  Supplier Batch
                </span>
              </div>
              <button
                onClick={() => setShowSupplierBatchModal(false)}
                style={{
                  background: "rgba(255,255,255,0.12)",
                  border: "none",
                  borderRadius: "6px",
                  color: "#fff",
                  width: "28px",
                  height: "28px",
                  cursor: "pointer",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div style={{ padding: "20px", maxHeight: "55vh", overflowY: "auto" }}>
              {supplierBatches.length === 0 && (
                <div
                  style={{
                    textAlign: "center",
                    color: "#94a3b8",
                    padding: "20px 0",
                    fontSize: "13px",
                  }}
                >
                  No batches added yet. Click <b>+</b> to add one.
                </div>
              )}

              {supplierBatches.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "6px",
                    padding: "0 0 0 36px",
                  }}
                >
                  <span style={{ flex: "2 1 0", fontSize: "11px", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase" }}>
                    Batch No
                  </span>
                  <span style={{ flex: "1 1 0", fontSize: "11px", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase" }}>
                    Qty
                  </span>
                  <span style={{ flex: "1 1 0", fontSize: "11px", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase" }}>
                    UOM
                  </span>
                  <span style={{ width: "34px", flexShrink: 0 }} />
                </div>
              )}

              {supplierBatches.map((batch, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      background: "#f1f5f9",
                      borderRadius: "6px",
                      width: "28px",
                      height: "34px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "#64748b",
                      flexShrink: 0,
                    }}
                  >
                    {index + 1}
                  </div>
                  <input
                    className="form-control"
                    style={{
                      flex: "2 1 0",
                      fontSize: "13px",
                      height: "34px",
                      borderColor: "#e2e8f0",
                      borderRadius: "6px",
                      background: batch.batch_number ? "#fff" : "#f8fafc",
                    }}
                    placeholder={`Batch ${index + 1}`}
                    value={batch.batch_number}
                    onChange={(e) => {
                      const updated = [...supplierBatches];
                      updated[index] = { ...updated[index], batch_number: e.target.value };
                      setSupplierBatches(updated);
                    }}
                  />
                  <input
                    className="form-control"
                    type="number"
                    style={{
                      flex: "1 1 0",
                      fontSize: "13px",
                      height: "34px",
                      borderColor: "#e2e8f0",
                      borderRadius: "6px",
                      background: batch.qty ? "#fff" : "#f8fafc",
                    }}
                    placeholder="Qty"
                    value={batch.qty}
                    onChange={(e) => {
                      const updated = [...supplierBatches];
                      updated[index] = { ...updated[index], qty: e.target.value };
                      setSupplierBatches(updated);
                    }}
                  />
                  <input
                    className="form-control"
                    style={{
                      flex: "1 1 0",
                      fontSize: "13px",
                      height: "34px",
                      borderColor: "#e2e8f0",
                      borderRadius: "6px",
                      background: batch.uom ? "#fff" : "#f8fafc",
                    }}
                    placeholder="UOM"
                    value={batch.uom}
                    onChange={(e) => {
                      const updated = [...supplierBatches];
                      updated[index] = { ...updated[index], uom: e.target.value };
                      setSupplierBatches(updated);
                    }}
                  />
                  <button
                    onClick={() =>
                      setSupplierBatches(supplierBatches.filter((_, i) => i !== index))
                    }
                    style={{
                      background: "#fee2e2",
                      border: "none",
                      borderRadius: "6px",
                      color: "#dc2626",
                      width: "34px",
                      height: "34px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                    title="Remove"
                  >
                    −
                  </button>
                </div>
              ))}

              {/* Add row */}
              <button
                onClick={() =>
                  setSupplierBatches([
                    ...supplierBatches,
                    { batch_number: "", qty: "", uom: modalData?.[currentRowIndex]?.uom || "" },
                  ])
                }
                style={{
                  marginTop: "4px",
                  background: "#f1f5f9",
                  border: "1.5px dashed #cbd5e1",
                  borderRadius: "7px",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: 600,
                  padding: "7px 18px",
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                }}
              >
                <span style={{ fontSize: "18px", lineHeight: 1 }}>+</span> Add Batch
              </button>
            </div>

            {/* Footer */}
            <div
              style={{
                padding: "14px 20px",
                borderTop: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                background: "#f8fafc",
              }}
            >
              <button
                className="btn btn-outline-secondary btn-sm"
                style={{ fontSize: "13px", padding: "6px 18px" }}
                onClick={() => setShowSupplierBatchModal(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  background: "#1e293b",
                  color: "#fff",
                  border: "none",
                  borderRadius: "7px",
                  fontSize: "13px",
                  fontWeight: 600,
                  padding: "6px 22px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const updatedRows = [...modalData];
                  updatedRows[currentRowIndex].supplier_batches = supplierBatches;
                  setModalData(updatedRows);
                  setShowSupplierBatchModal(false);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

    </Layout>
  );
};

export default GoodsReceipt;